import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/rafaelosorio/Documents/GitHub/tech-academy-apac/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const FeatureCard = makeShortcode("FeatureCard");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <FeatureCard title="Develop a REST API using ACE Toolkit to interact with MQ" color="dark" mdxType="FeatureCard">
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "36.11111111111111%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAIAAACHqfpvAAAACXBIWXMAAAsTAAALEwEAmpwYAAABpklEQVQY0w3Q207TYAAA4D6GN9x5p3jYhQsQwCBGTZSADshGAAchg62BjMkaKWzdv660/dfz+dyu606MNGJIfDx3911/yAXWogVD8we6E8qabTqRG8QzcJLBCWr5/Gr3qEKwKsVrgIKtdptlWdv1JVm5xnEEazIkI8mGJ8imZgVRMhlOUi8auGE/maSdrnpavWF47aR0hpZP0VLRdNxR+hT0RywLEYLioahDXpF1J4hHvVGaTP/Gw6nhhPeP/zR/iAMuv18sFw/ODgvbX9dIEvTHD6rpMBAiWOPuDiokLQCq6wQDI5qM0yc/mWqmF/YSipX2jtFnc3MfV5cWMy9Wsy+3cjka8jTbrV7WELTWxAmmAWADMKJq272x7g8tPxZkAwoaoMX1b7mN7z8ESf5Z2H6/8Ob5q7eVy/ovrL6V20FIKIuapVhBfP9oeZEbJgCqFKfOIOsuoKXN/NGHT19s02xRMJPNzr9bvMBusZtG/uAYOUF/V+tEs8N7yQOvWB1OxQhGNPxw/KerOngbrmwUMsvrlcr5zmHp9dLa/Mrn+m1nFlS7bv4HLZnVowYUSgQAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "banner",
          "title": "banner",
          "src": "/tech-academy-apac/static/2361b519e7c85f8492d64ef2aed3de1b/3cbba/lab2-banner.png",
          "srcSet": ["/tech-academy-apac/static/2361b519e7c85f8492d64ef2aed3de1b/7fc1e/lab2-banner.png 288w", "/tech-academy-apac/static/2361b519e7c85f8492d64ef2aed3de1b/a5df1/lab2-banner.png 576w", "/tech-academy-apac/static/2361b519e7c85f8492d64ef2aed3de1b/3cbba/lab2-banner.png 1152w", "/tech-academy-apac/static/2361b519e7c85f8492d64ef2aed3de1b/0b124/lab2-banner.png 1728w", "/tech-academy-apac/static/2361b519e7c85f8492d64ef2aed3de1b/59ab2/lab2-banner.png 1800w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </FeatureCard>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Lab Overview</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Prerequisites</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Lab Environment</AnchorLink>
  <AnchorLink mdxType="AnchorLink">0 - Preparation</AnchorLink>
  <AnchorLink mdxType="AnchorLink">1 - Low Code / No Code Development with ACE Toolkit</AnchorLink>
  <AnchorLink mdxType="AnchorLink">2 - Generate the BAR file</AnchorLink>
  <AnchorLink mdxType="AnchorLink">3 - Deploy BAR file using ACE Dashboard</AnchorLink>
  <AnchorLink mdxType="AnchorLink">4 - Testing the API</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Summary</AnchorLink>
    </AnchorLinks>
    <hr></hr>
    <h2>{`Lab Overview`}</h2>
    <p>{`IBM MQ can transport any type of data as messages, enabling businesses to build flexible and reusable architectures. It works with a broad range of computing platforms, applications, web services and communications protocols for security-rich message delivery. IBM MQ provides a communications layer for visibility and control of the flow of messages and data inside and outside your organization.`}</p>
    <p>{`This session explains the steps need to create an Integration Flow developed with ACE Toolkit that uses the REST API functionality as well as the MQ Nodes to interact with an MQ Queue Manager using the latest version of the ACE Integration Server Certified Container (ACEcc) as part of the IBM Cloud Pak for Integration (CP4I).`}</p>
    <p>{`Lab’s takeways:`}</p>
    <ul>
      <li parentName="ul">{`Creating an integration flow that connects to a message queue`}</li>
      <li parentName="ul">{`Deploying the integration flow as a container in Kubernetes`}</li>
      <li parentName="ul">{`Checking the message using MQ Web Console`}</li>
    </ul>
    <hr></hr>
    <h2>{`Prerequisites`}</h2>
    <ul>
      <li parentName="ul">{`You need to have an OpenShift environment with CP4I. For this session, your proctor will provide you a pre-installed environment, with admin access (more details below). If you want to create your personal environment, you can request an environment on IBM TechZone.`}</li>
      <li parentName="ul">{`You should have an MQ Queue Manager runtime pre-created in your CP4I on ROKS environment.`}</li>
      <li parentName="ul">{`You need to have the IBM App Connect Enterprise Toolkit installed in your desktop. Follow the sections Download IBM App Connect Enterprise for Developers and Install IBM App Connect Enterprise from `}<a href="https://www.ibm.com/docs/en/app-connect/11.0.0?topic=started-get-hands-experience" target="_blank">{`this tutorial`}</a>{` to install it.`}</li>
      <li parentName="ul">{`You need to download the OpenAPI spec. Open this `}<a href="https://github.ibm.com/joel-gomez/cp4i-tech-jam/raw/main/artifacts/jgrmqapi.json" target="_blank">{`page`}</a>{` and save as swagger.json. You will use this spec later in the lab.`}</li>
    </ul>
    <hr></hr>
    <h2>{`Lab Environment`}</h2>
    <p>{`For this session you will use a ROKS 4.10 environment with Cloud Pak for Integration 2022.2. For this section, your lab proctors pre-installed this cluster for you with a pre-configured IBM MQ instance.`}</p>
    <hr></hr>
    <h2>{`0 - Preparation`}</h2>
    <p>{`In this section you will do some initial steps to prepare your environment for the lab.`}</p>
    <p>{`Next steps, assume that you already accepted the Account invitation in IBM Cloud (account: 2543884 - itztsglenablement05). This is the same account of GitOps lab. If you didn’t accept, please check `}<a href="https://ibm-integration.github.io/tech-academy-apac/gitops/#0-preparation" target="_blank">{`the GitOps lab preparation section`}</a>{` to complete it. `}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Log in `}<a href="https://cloud.ibm.com/" target="_blank">{`IBM Cloud`}</a>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In IBM Cloud dashboard, change your IBM Cloud account to `}<strong parentName="p">{`2543884 - itztsglenablement05`}</strong>{`.`}</p>
      </li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "70.83333333333333%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAABYlAAAWJQFJUiTwAAACrUlEQVQ4y41TS08TURTurzCBxJqyAeoLIaGJCsQFVPoQoWpUjBpXGqJgYgJoiCtdGxJXJiYm+gM0/gD3rFxAZFGkUCjttJ33687M/Tj3FmuIQZ3ky5k595zvnPOdO7FcLscKhQITNp1OH8L4+DjL5/Msk8mwbDYrYwSGh4bYYCrFLqRSwWhvd5Ts6WFjY6NsZmaGxWzbRrlcRrFYRLVahWEY0HW9DU3T2hDfjUYDVAydHR1IJLpwvPMYTg7m8e27CUtXEPN9n2uaym3b5EHg8TAMyP4Jxhidhdx1XT5VKPDeZJL3Dwzw+Ik4z00UuGEHXNc1HnNdB8ufdvFwcROP57bx8UMTtm3ANC2I7h3HgWVZ0lJx2eXkxBUku7vRd+Y0EvE4rk1N0plLU+iQhLMvN3Ex/QNjwxt4NV9DaauIjY2fqFQqUFUV6+vrWFtdRaPZxO7WFq5fGsH5U0mM9J1Ff1cCt7MZ7FX2pCwxz7OxsFTG6EgRN4Z38HZJQ3lnkwjWpLaiu1KpJMkt6lglDZ/PPsGDWzfx6P49TE9excLTORkrCRlz8OLZHi6f28Z0Xx3v5m001RoF7MgFiFFFoGmaktymb4X8Sr0Blfw1RaH3ujwnfWkpzMX75ToW71bw+k4dX97oRKgQWRMW6ShIxPabNK5IMkhDpVaT+npEoJK/LgkNWZxG9lrXgSo6dkt42uoh0HYJARi9O14oyUQBkfcrxnbpzKEOAwoW7GHI8D9PxNHefhCEB16OKAKN7CEmqltOAMvl1AEH50cjoqyAJjBthpoWomlGUC1OlsNw+G9C1YpQ1SKYTkSJkUw8CjrdUZdk8vyArE9NUJGo1SXzDwgNIqKf4K/dCYgki66Z0Ozww+H4HJrhtghFZen+B2FIYTSAXFLbF3KZ+3klwtcVB/vqC8e7dElkoAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "gitops 0 3",
        "title": "gitops 0 3",
        "src": "/tech-academy-apac/static/3fae56861c204833ffbdfc4963553a2d/3cbba/gitops-0-3.png",
        "srcSet": ["/tech-academy-apac/static/3fae56861c204833ffbdfc4963553a2d/7fc1e/gitops-0-3.png 288w", "/tech-academy-apac/static/3fae56861c204833ffbdfc4963553a2d/a5df1/gitops-0-3.png 576w", "/tech-academy-apac/static/3fae56861c204833ffbdfc4963553a2d/3cbba/gitops-0-3.png 1152w", "/tech-academy-apac/static/3fae56861c204833ffbdfc4963553a2d/0b124/gitops-0-3.png 1728w", "/tech-academy-apac/static/3fae56861c204833ffbdfc4963553a2d/4ea69/gitops-0-3.png 2304w", "/tech-academy-apac/static/3fae56861c204833ffbdfc4963553a2d/b8a32/gitops-0-3.png 2522w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">
        <p parentName="li">{`Now, click `}<a href="/tech-academy-apac/environments/" target="_blank">{`here`}</a>{` to open the `}<strong parentName="p">{`Team Environments`}</strong>{` page.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click to go to the `}<strong parentName="p">{`End-to-End Labs - Team Environments`}</strong>{`.`}</p>
      </li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "31.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAYAAADDl76dAAAACXBIWXMAABYlAAAWJQFJUiTwAAABGUlEQVQY033Qy06DQBQG4OmmC+hbFDaEUN+Vde2qT6G0LnSnNqm66CUUaBUpcpEB6qL0d2aoBF14ki9ncnL4MwMZjS4xHA4xHo9hmiYkSQIhRHRZloVer4dutyvmnU7nXySKP5GmKXj5vg9d19Hv92EYBgZnF4MBNE2DwuaqqkJVlBo//0GStA7M81wIw1DYtwR8FkWI4hjhR1RLkma3jaBVp9MJZVniwPiui81igZ1tw1uv4SyXcFcr5EmMAwsrdh4KtlcKxbmXIDyE43U8HkHZLSn74OVminvrCrPpBDN2frCu8Tix8HR3i/3zHJlj17tZBkpp41dgVVXi2ZRm2G+34pbcu+fizXFEf93YiIMA+eGrCfn5Xdw3ietvb/TG2DoAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "team cluster1",
        "title": "team cluster1",
        "src": "/tech-academy-apac/static/46f1003dd219752a53707d38150b40e3/3cbba/team-cluster1.png",
        "srcSet": ["/tech-academy-apac/static/46f1003dd219752a53707d38150b40e3/7fc1e/team-cluster1.png 288w", "/tech-academy-apac/static/46f1003dd219752a53707d38150b40e3/a5df1/team-cluster1.png 576w", "/tech-academy-apac/static/46f1003dd219752a53707d38150b40e3/3cbba/team-cluster1.png 1152w", "/tech-academy-apac/static/46f1003dd219752a53707d38150b40e3/0b124/team-cluster1.png 1728w", "/tech-academy-apac/static/46f1003dd219752a53707d38150b40e3/4ea69/team-cluster1.png 2304w", "/tech-academy-apac/static/46f1003dd219752a53707d38150b40e3/02e61/team-cluster1.png 2604w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`Open your Team’s section (A) (check the number of your team with the Lab’s proctors). Then, open your team’s `}<strong parentName="li">{`Cluster page`}</strong>{` (B).`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "62.15277777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAABYlAAAWJQFJUiTwAAABaElEQVQoz42T2W7CMBBF8/+I7QnEC//At6C2eaChZCMkTRyyUEBwO9eVVRdC20hH43g8N7M4zmQywWw2w3w+x3Q6xWg0wmAwQL/f13Y4HGproH88Ht/R6/WwWCzgvOcKbdPAfg6HA6qqQl3XaNtWW77v93ucz2dcLpcfXK9XHUefczqdQI7How4qyxK+72O9XsPzPIRhiO12iziOEUfR99oiz3MdRxw7M2ZTSTZ2ENcMKIpCowxKabhnqqF1mK6hZamqQOi+IPVeoeIIKgqFyCLU+4VUUYtgI+2qbwX5fAl+oMoyBM9P2Hghok2CIvChdglUYpHuoDZv+mwlgtVDQZYsjQ9WK2SSTclAinWRbPVZI0TLFtwLsofMQhrccMIsqQNmZsSMIPt5LyhODoNOO+AWXqHaen+coTh5VTjZPwXFb85wOKRTMGHJ8rXfBO1BUChNU2QypE7BIAj+V7L4afljLJdLuK6LTwUYgX1A3TjPAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "team cluster2",
        "title": "team cluster2",
        "src": "/tech-academy-apac/static/aad85d48832915e8e4c8c90823a1f264/3cbba/team-cluster2.png",
        "srcSet": ["/tech-academy-apac/static/aad85d48832915e8e4c8c90823a1f264/7fc1e/team-cluster2.png 288w", "/tech-academy-apac/static/aad85d48832915e8e4c8c90823a1f264/a5df1/team-cluster2.png 576w", "/tech-academy-apac/static/aad85d48832915e8e4c8c90823a1f264/3cbba/team-cluster2.png 1152w", "/tech-academy-apac/static/aad85d48832915e8e4c8c90823a1f264/0b124/team-cluster2.png 1728w", "/tech-academy-apac/static/aad85d48832915e8e4c8c90823a1f264/4ea69/team-cluster2.png 2304w", "/tech-academy-apac/static/aad85d48832915e8e4c8c90823a1f264/d3591/team-cluster2.png 3078w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">{`On your cluster’s page, click `}<strong parentName="li">{`OpenShift web console`}</strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "66.66666666666666%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAACN0lEQVQ4y3WTy27TQBSG84qIZQlCCFoFK0qySB6CDYuIDQsknoAtqwooEkrKbVUESRoualI7deLb2HOLf86ZxBYV9EhHnrFnvvOfixveIw/dbg+e56HdbmMwGKDf72PQ3z17va5732614N2+Be9uE807R2g2Wzg4OML9e4fodDp4+OAQw+EQjWx5icD3Ea5DBEGA9XpN6zVikaAoCnKJsiyx3W6hhUA0X+D5iws8eRbg8VMfJ8c+lDQoNJCkAo3JdI7fP39guVzugSGSJIE2BlJKhGEIQSDDe6VdwCy8gowjJCsfq8XCnbP0fbPZoOH7AeaXl0izDEWewydgJnKwWWuxoCBSKrfPZYGIglWmtEFKZ0tSzxbHMRqsZkkLBuakJMkKKGVciqxKmRKW1tYaaAJoWzo17hvtLbH4LHsURWhwOgV5xkBSmCQxKSrqQ0pJd5mN95LqyjWtMuCsqu9OIYMqZ2Capq4WrJxrw++UUjUwdwBdB+TGVUAWdw0o9krTLKV0lEs1JsUiF25tSFGUGqqxJoitlQKlW3OwGsjK2I2k6NLgJtMEsnanjlNmsCgsNYye4i9gQjBNsNH3T3j54RVOzsd4Mxvh7Wzs/HjyHl/96U5PrWxnu8bgX4WShngyO8PpdISPBHn9bYTT8y94dzbCePYZv9YXe8BOXVXHyq8BqxoKmvY8ETemzA0yWtd/D4OrEvwXyEoFd5aaUmgaE/JtuXe6xH/OarVyk8Bzx6PCE8Hd5vt/ADBYyb7nDYQqAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "openshift console",
        "title": "openshift console",
        "src": "/tech-academy-apac/static/7dbb56dc17771ea07c3394514d12e940/3cbba/openshift-console.png",
        "srcSet": ["/tech-academy-apac/static/7dbb56dc17771ea07c3394514d12e940/7fc1e/openshift-console.png 288w", "/tech-academy-apac/static/7dbb56dc17771ea07c3394514d12e940/a5df1/openshift-console.png 576w", "/tech-academy-apac/static/7dbb56dc17771ea07c3394514d12e940/3cbba/openshift-console.png 1152w", "/tech-academy-apac/static/7dbb56dc17771ea07c3394514d12e940/b485f/openshift-console.png 1302w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">{`Great, now let’s check your Cloud Pak for Integration environment. First we need to get the Platform Navigator URL and password. Let’s do it! Back to the OpenShift Web Console, open `}<strong parentName="li">{`Workloads`}</strong>{` (A) and `}<strong parentName="li">{`Secrets`}</strong>{` (B) again.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.59722222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAABz0lEQVQoz42R3U7bQBCF9yWKVMlAKdSEFCeBJG6diuBYjVDVAG4QiLuqUh+yD9GLXvaqUiV+pKoFBxzH3l3vYXaD8yNQxUgj767PfjNnli1aFuqVCtZKG7BtG77vw3VdNJtNeJ6HVqs1l/qs3W4jCAJ0Oh1a76LbfY+wt4e9bgC2W9tCUG/AsTfQPzmFEAJxHENKiacGJ+n3X0OcXQmwdwRzKzWUVl8hPDrG7c2NAeZ5buA6lVJmr7/jUHPAYSrx7cc1fp4nYPZmFY3WDhasF+jtHyJKqMORAOeZgUWDCEmSGODgNsYok8gEFZOC9hGdq7kCzN+u44P7Bm75NfbDPlKhIPNpdX2x6PLsKjP5LxYEleAim3Qs6JKkoswpO2iQ5aWlFfQOP5FQYcRzpDQYLSqAOQEvrzOcU15GGWl0p5nR6o71f12Ulchyyanh2XMLvYMQo3ugFkmywwUn+5zAEr//prgg4J8BJ40gN6lxxMV4vga4Wd3GW5qhtfwSHwk4Gfq9oBiPnlU0pLkl4xRy9oHUFLiuLbse1tbLOAiPxhJVCKbrx2KqU5M9q2w1UHaqWCDLYf/4gfB/OdtZAWXeTgd+0IW2/vnL1zngU2O2wztpyNl0UXqCWgAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore7 1",
        "title": "explore7 1",
        "src": "/tech-academy-apac/static/1ffdc06eb354c68fd92a5d5607d74158/3cbba/explore7_1.png",
        "srcSet": ["/tech-academy-apac/static/1ffdc06eb354c68fd92a5d5607d74158/7fc1e/explore7_1.png 288w", "/tech-academy-apac/static/1ffdc06eb354c68fd92a5d5607d74158/a5df1/explore7_1.png 576w", "/tech-academy-apac/static/1ffdc06eb354c68fd92a5d5607d74158/3cbba/explore7_1.png 1152w", "/tech-academy-apac/static/1ffdc06eb354c68fd92a5d5607d74158/26482/explore7_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 8
    }}>
      <li parentName="ol">{`Now filter by `}<strong parentName="li">{`cp4i`}</strong>{` project (A) and open the `}<strong parentName="li">{`ibm-iam-bindinfo-platform-auth-idp-credentials`}</strong>{` secret (B).`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "61.45833333333333%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACUklEQVQoz2WS207bQBCG8xBVxakQKEnIyXaCE9KmEUKoVa/7Ztz3ATgICBf0DVoJqZe9aWlUIUhScrQTx45jJ193LYxCsTQaaXb38//PTGRtdRU1tkkunycaXSevKBSULFoywaf9PXYKOqqqomlakIvFIqVSiXK5HGQZu7u7VCoVdF0nkkwrKDmdWCLJ4uo6nw8OaHy/4ufXb/Tu6ty3uzQaDVqtFu12O8gyms0m9Xr92VkkrWjEkxk2YlssCeDp2SngY9hTTGeK68N47PD/5zgOpmkyGo2e1CNqvhAoXN9MsCyAJ8dH4Dm0+jb9octk4jEcDESeMJ1O8X0fzxO14ZBer0e/38d13cd6JJlRSKSyRF/HWVyJcnJyDLMJneEEU6j0pmA5Np54MJvNAqiMEGgYRgCSZwEwtpVGL74JoC8Wljk+PBQEk9Z9D7M3YGQMsO5u8YXCmbAkYfKxtDwQyqVl/+FnMkfU7SL77z+yLaAb8RRnR4fYtV9c/6jR/H1Dt/YHs3b9CApV2rYdAC3LelQYAHPFMnv7HyiUymQ1nS+Xl3hmn9u7Lr2OidE1sYYW/hxQhgTKoUjrT4CxRIqMmhdDifNy6RXV6rk0xl/DxXJnTEQPbWEvtBVGaPmZQtnDtJITa5MIhlKtVgVvIiY8xh6Li0JZ2KdwINOHWqhwfgMiiVSGUrlCKquxsLJG9fwM3BEdc4wjltAVY5ZKQhVhDyWo2+0GayOBwZQlMJlRg/7tvH3H2kaci4sqM9/jpjViaHvikgDO9Wm+h51O58naSIX/AARaAxeCRjEiAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore7 2",
        "title": "explore7 2",
        "src": "/tech-academy-apac/static/4180e2a3ad8ab3076dda18807f7d30ba/3cbba/explore7_2.png",
        "srcSet": ["/tech-academy-apac/static/4180e2a3ad8ab3076dda18807f7d30ba/7fc1e/explore7_2.png 288w", "/tech-academy-apac/static/4180e2a3ad8ab3076dda18807f7d30ba/a5df1/explore7_2.png 576w", "/tech-academy-apac/static/4180e2a3ad8ab3076dda18807f7d30ba/3cbba/explore7_2.png 1152w", "/tech-academy-apac/static/4180e2a3ad8ab3076dda18807f7d30ba/026b8/explore7_2.png 1288w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 9
    }}>
      <li parentName="ol">{`Scroll down and click to copy the `}<strong parentName="li">{`admin_password`}</strong>{`. You are welcome to take note of this password.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB40lEQVQoz6VSW08aQRTeP9DaVsECQmprtBWQi5eKIDQaXnxrH3xrLaLWmAiECIRe/6R9apv2obZNqLAXl9nZC1/PjvrkkpB0ki979sycb77vnJFmtraQ2t7G7IvnCBaLGFtbw+1MBrdWV8XXt76OyUJBwJ/Pi/ydbBbjFN+jvbu5nIiv/6VHwRCWozFMhyPIrTzFu5MTVA4P0azV0CI0qtUrVChXRZPidr2OD80m3jcaeEvnP7Za+NRui5wUSy9jLpaALxDGwdEx/ndJ8eQi4sk0fPdDePW6DEuX0fl+ir8/PhNO0fv1Ddr5HzBdA+cclmV5wrZtsS8lSGEml0cw/AA7pT1YnEHu/IahdcHUcxgXMqEHQ1dgW1yoGAwGN+Aux3EgZQubeLZRRHQhhUqtDr3P0VP1oZaui70IXaXSfDwpyPyBKVJYhqb3oagqyTfdKs/CYZcIy7FEGi7puD+IlzslMNrQDRvMdDyteeKKmHPD7eGS6GEo8pCGskuNsGGZ5tBeeSm2DQOMO+ibNqQn9GRSSyuITM9gd+9ANFZRFDG1UeAQqdHpQPv6BerZ2eWU5+bjZDmA8v4bcWu324VJKkeFRTVMlonw56XCx9EFTEyGUCrvCwuMsZEVCrjvkJz1aSj/ANenAxmnf66LAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore7 3",
        "title": "explore7 3",
        "src": "/tech-academy-apac/static/e60321abef975a46b5c7f1875f67d1ee/3cbba/explore7_3.png",
        "srcSet": ["/tech-academy-apac/static/e60321abef975a46b5c7f1875f67d1ee/7fc1e/explore7_3.png 288w", "/tech-academy-apac/static/e60321abef975a46b5c7f1875f67d1ee/a5df1/explore7_3.png 576w", "/tech-academy-apac/static/e60321abef975a46b5c7f1875f67d1ee/3cbba/explore7_3.png 1152w", "/tech-academy-apac/static/e60321abef975a46b5c7f1875f67d1ee/26482/explore7_3.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 10
    }}>
      <li parentName="ol">{`Now, let’s get the Platform Navigator URL. Open `}<strong parentName="li">{`Networking`}</strong>{` (A) and `}<strong parentName="li">{`Routes`}</strong>{` (B).`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAABy0lEQVQoz6VRTU8aURSdP1Bt1QoFtSQMaNU6gihfjnbDwqbduHGjVVAJjYkYIxBMP35k22XTrkjTVqd8DDPz5uP0vldJF8CCeJOTd+fed8+c864kv9xBfG8P0d1dBHI5jGcyGEun8SCVEudjVYVve1tgemtL1B9ms5ikfIJ6jzY3Rd77luTgDFYiUTylU02mcH11hfNSCdWLC9QIlXL5DudUK6NKef3yEu+rVbyrVMT9D7UaPtbroiY9U+KYX1Yw6Q/i9O0Z7hvSMhEq8XVM+QLIHxfhmS38+vYJv79/IXyG1viK9s0PGHoblmXBtu2BcBxH9CVldQ2q+gLhyIIghGtD+9mA2b6F0bqB2flD0GDqTTi2JVR4ntcHHq7rQtpJJPBqIwlZjhLhKUzm4LbZGWqpNzyIkCuVckT4mjYXCoWx/+YIHd1As9Ui+YxPDRwc9pN/lpUYNhJJ+AOzODjMw6SGbjowmDvQ2jDwYJxwaSWGyMISfER4mD+G69AjMzb0rfqICI7rkQAPumFCek5LkecXiXAOR4UTYZVb5lsbBRazoXe7/xVOP5kRhLbNoGkaGKkcFV1OGKP34/AH51A4KQqrhmGMrJBvmBP+BR95A7816F7AAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore8 1",
        "title": "explore8 1",
        "src": "/tech-academy-apac/static/ace7b62eb2aeed845d96cbcbe20a3df1/3cbba/explore8_1.png",
        "srcSet": ["/tech-academy-apac/static/ace7b62eb2aeed845d96cbcbe20a3df1/7fc1e/explore8_1.png 288w", "/tech-academy-apac/static/ace7b62eb2aeed845d96cbcbe20a3df1/a5df1/explore8_1.png 576w", "/tech-academy-apac/static/ace7b62eb2aeed845d96cbcbe20a3df1/3cbba/explore8_1.png 1152w", "/tech-academy-apac/static/ace7b62eb2aeed845d96cbcbe20a3df1/26482/explore8_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 11
    }}>
      <li parentName="ol">{`Scroll down and click on the `}<strong parentName="li">{`cp4i-navigator-pn`}</strong>{` location to open the Platform Navigator.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "61.45833333333333%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACe0lEQVQoz1VT227TQBD1X0BvaXpJ2zRt4qSpkrZErXhCQnwigld6UUvhAcRX8NAXBK1IE9tx7MR2Ysde7/owu25ArDUae/fo7Jk5Y221UECttIl6o4FisYh6vYHmQQO1apXedei6Trmusq7XcNRu4fj4CCcnJ2i3WvTdxtnZKTqdDprNJrSdShX7+gFK27tYWF7F23fv0TUd/HzowrBsmAMLvX4Ptm2jZ9j43bNUHtgWHo0u+uaQwsZwOFQYrVKto7xXw3ppBwsrRVxd30AuxjMI5CvLMpUHvsC9zWB5HDNG+/SITOZ/S9ve3VcK1za38XypgA/nF+pgGsXgXCBNGWZxDME57HEMN0gwiRjCWUykMRK6dZakYCknPIe2Vd7DXq2hFD5bXMH5xaUiDEmCIGVccMRJrFRaAUdvlGIcZZiwDL7vw7PHiNMMKV0uhMgJpUJFSArnhIylikSCZGQURs/BwHARuB5mroPw7juY5+UlP2E1qU72UJa8VFjDxeWV6p03TVQfUy7LiyCSBOavPu67Y5iWj6kzhGsZGEbAeMKo5CeFtcYhZEjCRTJFEsqVprnCuSEZY3j80SVnPXLURzB0kQW+UjfHKcLdfT0fm50KllfXcXl1DTKQGs0UUZImmIZTZYrZdyhcuIMxpiMH/mSUu50JRcjoUq3VeYlXr9/g6MUpGodtfPn6TREJMuP/gQBMGhebjKFuIObz3ewvTlalSWX1ZgulckW5fPPxVikcBTFiJigShFGoynH8BANPjk4+Nl4YYDqTGK7OFWG1fgD5t2xslbFS3MDtp8/qtijOx0YC5ehIF81xgofBDMYoITJpREqmZQo37+EfMjoDNtXWOdwAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore8 2",
        "title": "explore8 2",
        "src": "/tech-academy-apac/static/10714e35dce5a20bfcb8f7a7ab69fa63/3cbba/explore8_2.png",
        "srcSet": ["/tech-academy-apac/static/10714e35dce5a20bfcb8f7a7ab69fa63/7fc1e/explore8_2.png 288w", "/tech-academy-apac/static/10714e35dce5a20bfcb8f7a7ab69fa63/a5df1/explore8_2.png 576w", "/tech-academy-apac/static/10714e35dce5a20bfcb8f7a7ab69fa63/3cbba/explore8_2.png 1152w", "/tech-academy-apac/static/10714e35dce5a20bfcb8f7a7ab69fa63/026b8/explore8_2.png 1288w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 12
    }}>
      <li parentName="ol">{`If necessary, accept all the risks, and click `}<strong parentName="li">{`IBM provided credentials (admin only)`}</strong>{` link.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAABtElEQVQoz5WTvU7rQBCFeQgSO04c8Hp3ba+jXIc4QEAC8S+4Eop0JQqukCiQoCQtJRUtFBTUPAC0PAZvwJMcZjaySYIQUIx219Z8O2fm7IzjOKhWq+B1Ovh7rVZDFEWI49iuxb44j++TJMHM74AFJPl8Af37MVBzolZlcigDaK0JYOxZKWnDGDMJ5HU6bIWUnLYyW5km8N/tI3SyDoTwLSjv9um8SBfqD2ABZYDneTZGQNdK3Ty5RdpZR7Pp4O7qBQ83r9g9+I8g9HF0OMRg/xxCzo2ApTyvhkAEUFSFpJsrlUoJXNn6h4SqFGGA89NLPD++4eoeUNkm/iQxUtOmFsQfwFlKbtQbJM9AyRhifh5114XLPSQ4y837GzDtLhbyLvZ3DjE4e4LKDxC2UtvncigVqs53HSwRJA8VciHREyHavk9AD1I00VsbYO/4GlFs0FvcQjdbRsSDWFlDfjG0KkrgLAHTRh2aJFuZLN+hnhZTVgqtdgdZvmqHwhbhihliqLqF/vKkD4sqGVzlfhYx5kOe4Eg6+S+eNLSW8nfGZs999Tq+fSl2P+bL6adXAMoY+8fGfgfM+1ovaWdUDQAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore8 3",
        "title": "explore8 3",
        "src": "/tech-academy-apac/static/f8d1105326e922dfbb8708a2a47ebc25/3cbba/explore8_3.png",
        "srcSet": ["/tech-academy-apac/static/f8d1105326e922dfbb8708a2a47ebc25/7fc1e/explore8_3.png 288w", "/tech-academy-apac/static/f8d1105326e922dfbb8708a2a47ebc25/a5df1/explore8_3.png 576w", "/tech-academy-apac/static/f8d1105326e922dfbb8708a2a47ebc25/3cbba/explore8_3.png 1152w", "/tech-academy-apac/static/f8d1105326e922dfbb8708a2a47ebc25/26482/explore8_3.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 13
    }}>
      <li parentName="ol">{`Log in with `}<strong parentName="li">{`admin`}</strong>{` user and the password that you copied in the previous step.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB+klEQVQoz5VTu27UQBR1SYlQbI8fY69f4xl7tdi7TpQNKEDCQwkoWoSUggiJAimUSbtlaGihoKDmA6DlM/gDvuRwZ9a7bEJSUByN74zvmXPvPWO5rgvHcaDXq9D7nuehLEtIKc26/F7G699KKVjXEd1MuCRR/15AZ4ZQJ23Y9go2xU4PuycUOlEUq+QsTyCEIILKxEWRG1RVBUsnZIMYIssMAsbgM9eszHXAtEJKroeNUSaI+PnjY7RNizTlhqibTCneogsFLMlDtLTZ0I9j2lARR+4xFL4HFfhgRKxL3XvzCXX7AFHk4vP8J75+/IWnhydIMo7jo3PMDk6R5jGsWquTFcIoBo8XCDmnOIIMQ3g94c7+KyhSmWYJTt+e4ce335h/AYpmD3eVRF2NqAUSluI+xMBGOvCRJCkpiAxiIpZhsOghVaDL7aaPUI0mGHcTHDw5wuzddxTdIbJhbfpshqIShfD+HHz4AlHggoecECIiVIbQR55G2Nyd4dnrC5RUzebWPibNNko9iJ1ddO/PTRWGMB+QBR5+QDF6iZII8iBA1vewJDCjsMBw1KLp7pmhaItoxZqkInXj6fZfHzrOBtidW2D2bRqA33twYXR7zYd6govSyX/ysqFFnl82tuN6BLbyn3PF2NpzN72Oa1/K/zy9JcEKa2fa2H8AUk1eGhwkGc4AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore8 4",
        "title": "explore8 4",
        "src": "/tech-academy-apac/static/1c101359e9491a1e71bfad8d59907fca/3cbba/explore8_4.png",
        "srcSet": ["/tech-academy-apac/static/1c101359e9491a1e71bfad8d59907fca/7fc1e/explore8_4.png 288w", "/tech-academy-apac/static/1c101359e9491a1e71bfad8d59907fca/a5df1/explore8_4.png 576w", "/tech-academy-apac/static/1c101359e9491a1e71bfad8d59907fca/3cbba/explore8_4.png 1152w", "/tech-academy-apac/static/1c101359e9491a1e71bfad8d59907fca/26482/explore8_4.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 14
    }}>
      <li parentName="ol">{`Close the `}<strong parentName="li">{`Welcome`}</strong>{` dialog. Great, now you are ready for the lab. Enjoy it!`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB+klEQVQoz3VTyW4TQRAdYrxgW8KxZ+mZnh57PKuXKMIKPmCyiEUKCLhx5JJDjrlEHJH4ASQO/O+jqpx25gCHp+qaqXpV9arbUUqBEUURgiCA7/ti/wfP55gA6sHneIbWBuk8h6O1RhzHYMuwAb7vwvfchk8ggpiLkx17nnxTQUjEPsbjY+Q5EdoOLTgoCikpzhCZDDpSsEU9KlCaGOf5HOt5ilmxwXb7GYtyQxOGRFjA4UAGtx+GIabTKRIT4vL9V9zc/EFdVCjKElmW4fztJ6xOX2BZFDgrcpi0xurlNZKkJg6NqqoeR+bumJDPs9kMu90OVxfXWNRrCazrCq+/3OFksyO/RDJLZVStKTdQlJdguVjDaQprz0qRVialApEk7aXwMNYruL6m0T36Fop+jCikCT2FulruO+TOmtuVrT1snbfPMaPRCJ12C71eD47jYDgcypj8n8FFCpLCsdt97E7tkzsddLtdsUzSbj8VIovhYCDSGGMOOyhJ64OGTcJ+vy9JrVYLA0o8OnqCbu8Zvt3e4/7HL3z/+Rsnp2cijTGJdMi5QsgOj9y81FYCHoN913XFbl9d4uLNB1y9+4h5Vhyuk30UsuV/EfLV4UvK1mrEo/FiPHeC49FzOfM0HM+Wi0qHzWfV7NAWshc+SRLRjMFn+whszmQyEcK/ePQ+hD1IeZ8AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore9 1",
        "title": "explore9 1",
        "src": "/tech-academy-apac/static/846f80f6ac47b34e9d34fbf4f122ced2/3cbba/explore9_1.png",
        "srcSet": ["/tech-academy-apac/static/846f80f6ac47b34e9d34fbf4f122ced2/7fc1e/explore9_1.png 288w", "/tech-academy-apac/static/846f80f6ac47b34e9d34fbf4f122ced2/a5df1/explore9_1.png 576w", "/tech-academy-apac/static/846f80f6ac47b34e9d34fbf4f122ced2/3cbba/explore9_1.png 1152w", "/tech-academy-apac/static/846f80f6ac47b34e9d34fbf4f122ced2/26482/explore9_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <hr></hr>
    <h2>{`1 - Low Code / No Code Development with ACE Toolkit`}</h2>
    <ol>
      <li parentName="ol">{`Open the Toolkit in your workstation and create a new REST API project as shown below.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.94444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAAByElEQVQoz51SyY6cMBTk/78lt1zmHI0i5TKnSJNZ0mCgMc2OWWxjoPKemY66o5zGUsngpV69Kgf5pcTD6Q1ffj7hx+sLQpEgS8+o6gY1oWlaaK0xjiPatoW1FsYYD/6epsmvz/MMpXoEsurRNR2wA49xjG/Pv9ANCsuyYF1XOOew7xu0cXiNJMpu8mu879wCoy3eRY606IhUIxCyQVGVCLXCYyrw9TnBqSU1VUXqWGWNYRhgifyNLmZ5BU1qWNk0jURicEoKZJeKzikE/TCjJqnfa4lGKaR5D21XqL73bTIZt+zcht9CksqMBHCLkye1ZsEpzhGmBdqOWuZ2rmOhzTBTULPDRopux+ZWJFmBc16SV+pD4QRjF6SyhEhz73lwe0kbixdpUY8OK/lzO9y64z2+ICuOAJiMZ704hOcScXZYFIzj5Fuy1mBQA6K0psvb0Q5VN5Qkpzlrg6od0A8HEcMnTYSJLJBmF/Rdh+AsEwgRYSSDJ/JMUlrjfDwTTRe4mNZcTPmi6+p8ytekGf4ZWeOLBzu/l6tP2+bN5ur24/DtfKv4Dn/37b2HPhiuToHwfAcm/nftP2eCMIqoZeERRQL8H30SYRjiD9IYSbzPKseIAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit REST API with MQ Step 1",
        "title": "ACE Toolkit REST API with MQ Step 1",
        "src": "/tech-academy-apac/static/5ee76fe53038eab9c553ff3d361f127f/3cbba/2022-06-28_12-23-53.png",
        "srcSet": ["/tech-academy-apac/static/5ee76fe53038eab9c553ff3d361f127f/7fc1e/2022-06-28_12-23-53.png 288w", "/tech-academy-apac/static/5ee76fe53038eab9c553ff3d361f127f/a5df1/2022-06-28_12-23-53.png 576w", "/tech-academy-apac/static/5ee76fe53038eab9c553ff3d361f127f/3cbba/2022-06-28_12-23-53.png 1152w", "/tech-academy-apac/static/5ee76fe53038eab9c553ff3d361f127f/4c487/2022-06-28_12-23-53.png 1280w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Give a name to your project, i.e. `}<em parentName="li">{`MQAPI`}</em>{` and then select the option to `}<em parentName="li">{`Import resources`}</em>{` since we will leverage a definition already created.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "590px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "90.97222222222221%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAAAsTAAALEwEAmpwYAAADOUlEQVQ4y22UW27bRhSGuas+dwFeQF8LdAddQDeQ574EQZICSVG0SII4qQ0jcQLYkSVZimTR1pUiRVEUyeFFvEiy5Nh//6EukZs8fDicMzP/nDn/SErS16GHAzixhzTJkGYrEkmaQu/3oRsGepoGYzBAGEWIk+QbEhnjGIpt27hqNtFut9HpduEHAbLpFIvpDNezGWaLBTIKy1yaZri5ucHd3R1u13CAa+bKkwl0rlFul0uEvo9MnsLTEwomnBwFAi+1K/xw+hKdsYUpc74vsOQBVKHObY4UXH75gtokgjWn4IvWBfbVC/xZrWG/08VjivxWP8NDVcVHY4gHlTKGQYowvoY/mcMLp3CD7B4eETLvJ1D+qJ3h72oFjwpVPK2rOGhp+KyPMfZmcEgcLDB0MwycFCaR0Rgn36BLRiEU4bjQtB60Xg86o2tZsNh8Xe+jTzSSG8NoGDqs4RC+EBCeByE8eJ6bR4lsiSJN6Os6mq0WmjTGMM3czRHN2mCNRttvx3Vzp0UYIAhD9jZGzHEYRhQMoEgjHFZlsopI+EijCWZJmru8YTmbE0bpfMYXQLcxnWPO+FmMYUdhbmrA4pTGyMS/9QpelT7hSK3jtN/BCSkYGoqmTvo4G2gr+F3n+qJt4mG7jjLnfyy8xpNeAzcswpNX/v28jrelMvaLp3hT/ISDSglvSgUcnBfxtnyGQ47lt4yH5SJeV0t4UD3Fs4syxrz+SbeF3shCyOoEe6sUtC7eNVV8aKk4ljQbeE+Ot6zmPrQucXzV4NpGvnERxQj4flP2LlqL+RwrCRubso+7JGtkP7f5cBUz5uRP0fW8XMCTjq/F8gplYheX9sd0K+ICh5v+P58jxdYivriPskqKfCBPiChWsYdoOjbSIOQBX08XO9V83Sd2BFnh7iK5ec6r/VQ8xM+lIzgcTyjqeZsD/fuC30HZfGyEZaNV00BN1/Br4QgvepeYJxQN5YNezYvvVL1BGfOn5zjuNiH7I6uasvkD28I/dPZxpYPn1R4enbeg8olM6Gpuytrde6aYwxGGlp2/8m2VdF5edxFP8Oqyi70nNfzyVxt7T2t84AZN87nHyv9Q5T4pJqPkP3SMJ5CM0MpzAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit REST API with MQ Step 2",
        "title": "ACE Toolkit REST API with MQ Step 2",
        "src": "/tech-academy-apac/static/d348304f7abf64ee8ef0ad22e4b2e983/102e5/2022-06-28_12-25-32.png",
        "srcSet": ["/tech-academy-apac/static/d348304f7abf64ee8ef0ad22e4b2e983/7fc1e/2022-06-28_12-25-32.png 288w", "/tech-academy-apac/static/d348304f7abf64ee8ef0ad22e4b2e983/a5df1/2022-06-28_12-25-32.png 576w", "/tech-academy-apac/static/d348304f7abf64ee8ef0ad22e4b2e983/102e5/2022-06-28_12-25-32.png 590w"],
        "sizes": "(max-width: 590px) 100vw, 590px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`In the wizard click `}<em parentName="li">{`Browse`}</em>{` and navigate to the location where the OpenAPI file definition is located.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "590px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "90.97222222222221%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAAAsTAAALEwEAmpwYAAACAElEQVQ4y62UyW7bMBCG+fLty7ToqddecsihKaDUiJfa1r5LlExbkrfE/jtDSYXsLjDgEvgwQw75cxtSVJYNq3CQqAx1VaNqiLpG3TTYVBUs24ZNLE0TjuNArdc6vt5sLtiwpZiI4xjj8RjT2RSLxQKz2QyTyURjkggL1yRQkfh2u9V2t9vhfD7jdDqBHOxfX/GkFGzqK/aHAwpZYFWWKInVaqWRUiLPcz0zwz4Lc6yhgVxYlMuRhJ/XCj5NKLIsQ5IkiKIYaZqCV8x19pnWT9o+Ydj1jfSEilbFEyiiItaEMOYRjO8vmP9ot2oYz3rrrutqPM8j62nLZ9jDE/NimDTPEBIZITLabhCEsB0alFQUaBDJrSaUja73tO2tDbJa46YVPowMfPz2iE+zEYSks7EsC4ulCdNLsXQTbf24hJ+syHYM/a4epQrTMMf7rw/4bDzhy3zCZ5jD9319LmEQ0NZcqnsoi/6iio6yo60XxJ7S5MFd4t3oEW91A0Vxwbd3PB5xXfgG/8UbpwyVFyWxVIX2OW+14IFS51rk1qL7dv05nf4qeCvDfOQ8vUtwOOa/CF6L/yZ4b/l1hvr50DO6F04r0X8C/TO6lT+N4TYRJ/wBpLrSU1BSD32eVOaytR0XsUGb8PwQfhBdiPBHyb8KfwDs97H+e+PV8KvqYyzGlvkJF65aPMakmCkAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit REST API with MQ Step 3",
        "title": "ACE Toolkit REST API with MQ Step 3",
        "src": "/tech-academy-apac/static/717c0b14d4f7040694772c11509f61ac/102e5/2022-06-28_12-26-19.png",
        "srcSet": ["/tech-academy-apac/static/717c0b14d4f7040694772c11509f61ac/7fc1e/2022-06-28_12-26-19.png 288w", "/tech-academy-apac/static/717c0b14d4f7040694772c11509f61ac/a5df1/2022-06-28_12-26-19.png 576w", "/tech-academy-apac/static/717c0b14d4f7040694772c11509f61ac/102e5/2022-06-28_12-26-19.png 590w"],
        "sizes": "(max-width: 590px) 100vw, 590px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Once the path is displayed in the `}<em parentName="li">{`Location`}</em>{` field click `}<em parentName="li">{`Finish`}</em>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "590px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "90.97222222222221%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAAAsTAAALEwEAmpwYAAACUElEQVQ4y6VU227TQBD1H8IX8At8AeJjUF/hBQmJNyQkHlqRqsRxajdrN7bX98S33JUcZibYSgNUEax0NOPZ9ZnLzo7RKBeq8BCXKdqmRbMgtC3axQJ100C5LlzCw2QCz/NQVpXsV3X9BDVL2jOiKIJpmrAsC7ZtYzweYzQaCSZEsiDilggaIl8ulyJXqxUOhwP2+z1IwXq3w3VZwqWzxnqzQZ7nmM/nmM1mAtazLBPUv7zzGSbmfSblxaS8tkR8W5XwyaGRpgmSJAFHGsex6CwZaZqKXYehyJBkURTkoOodd6gIJcEY2Bq3d0NK0ZQ0OX1ONdQaQRAQQpG+72M6nRJxLKSMnEGR53kmekoZGWlWyA/e4xSWimE6IcYkLRXh3k0EQzsQG+vWJJLvH7YvckTfUZxC62P0Rk6sSik4zgNG9iPuLIXh2MW9CuG4WmA5PmylYZNuk308CXrYLhFGiZSDo6UaZpJORClG5CWkaMMwQFlSXejmRFLBWe9RHVFTm7DkGpZklwj5JrfbLc6XtAXh2B5Hvcf+aN9Su+wI3W1zFwjhhlqnI+nw3Or2uS/X63Vv5579K+ElOHfwbISXkJ1//xfhnxz8Rvgv67TafQ27a78U3C7xrIBf5FhWNQp+fmTPpbGpGZmU3+1zOD3DOr/5tzdfMNAeNlVBb5kGCTkxopiHQdJPFwY36KneOe10frNtMcMne4g3X7/h/UDh6sbBR8uBMfVD+IF+QsKDkqeN1lE/uvi9s53Lw9GFNDTqpsSrD9/x8mqIF+9MvP58jZ+lEFR2cV2DzwAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit REST API with MQ Step 4",
        "title": "ACE Toolkit REST API with MQ Step 4",
        "src": "/tech-academy-apac/static/a79a4ac0e70b3e3cb34c7518f643a9b8/102e5/2022-06-28_12-28-17.png",
        "srcSet": ["/tech-academy-apac/static/a79a4ac0e70b3e3cb34c7518f643a9b8/7fc1e/2022-06-28_12-28-17.png 288w", "/tech-academy-apac/static/a79a4ac0e70b3e3cb34c7518f643a9b8/a5df1/2022-06-28_12-28-17.png 576w", "/tech-academy-apac/static/a79a4ac0e70b3e3cb34c7518f643a9b8/102e5/2022-06-28_12-28-17.png 590w"],
        "sizes": "(max-width: 590px) 100vw, 590px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`The REST API will be displayed, scroll to the right if needed to open the sunflow operation as shown in the image to proceed to implement the API logic.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.94444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAABSElEQVQoz61Si26DMAzM///RvmC/sHVrC1XpCi2QB4GEhNxsWrapmyZNq6WTDfH5Lgax2hd4PRzwtM9RlCVqqaCURCtbSMX175BSommaOZdVCfGYrbHa7bA5Vdi2LTAl/DlSQooRkSDWdYVNdUTe1lCuh7UWUiucZY1Gk1OGuYJqfieNguk66M7A9T0qus3LLoclnrhV6r2DGXsc9RnNoNB6g8aRQN9eaz2f+ykgpoiTt3goNngmY8wX0zRRTjPYsiXFEMKMTyHaBPUt9dLPkZFzRSaQJuKHG4e4NEciMwI1MC1OEYEIJD0/py95ifmMHVo7wDkHRyreeyht0JkOHe2opq/X0U65NrSfYRgwjoEwfgPz+Vwc3vbIaaFM4oF13Xz8Blrri5jz8JQZPw3j9Tjicq9YdrFc978hcOcQ2yxDnud3QUaz3gEC4FSW1U6oIwAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit REST API with MQ Step 5",
        "title": "ACE Toolkit REST API with MQ Step 5",
        "src": "/tech-academy-apac/static/77429417d63b6715f13d60eb4cc97b79/3cbba/2022-06-28_12-31-05.png",
        "srcSet": ["/tech-academy-apac/static/77429417d63b6715f13d60eb4cc97b79/7fc1e/2022-06-28_12-31-05.png 288w", "/tech-academy-apac/static/77429417d63b6715f13d60eb4cc97b79/a5df1/2022-06-28_12-31-05.png 576w", "/tech-academy-apac/static/77429417d63b6715f13d60eb4cc97b79/3cbba/2022-06-28_12-31-05.png 1152w", "/tech-academy-apac/static/77429417d63b6715f13d60eb4cc97b79/4c487/2022-06-28_12-31-05.png 1280w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">{`The `}<em parentName="li">{`Message Flow Editor`}</em>{` will be open with only the `}<em parentName="li">{`Input`}</em>{` and `}<em parentName="li">{`Output`}</em>{` terminals. Double click the tab to maximize the editor and work with the flow.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.94444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAABaklEQVQoz52S226DMAyG8/7PNE272s1UqRfbylaxAmtDgLYcQjiEwr84LVXLuJhm6VMS+3dibNiWRwhFDB5HEHGM1XqNZ2eFJ+cVj4YH14ErOPb7PdI0RZZlV6Qs7Ho8Hi1hGIIFIoK/5ciLErKs4HsbqLLEYX/A58caOJ1QK2ViElWlLlRQxrcy8aKQ0Lq1Poqxtm1MsERnEnVT4X35giw3L+c5eChsopRyFs6FrXDUFEUBhhtr6hrLxQK666yIXhyTS1P1lNpUResYp5X1/YBhGOyFbddj8faJPEuvgr9gteV5f1chWWIGo7W2Fd5XpGarnMKUqtE0DaiXddNi6Xhw3S/4vm96FNrJcc4ttI+iaBaK2SnzcAs/8M3tZlqthrf5huf5EEJgd7lkt+NIkgS5GRQ1fgp9Kg2RYGP/yGh//qdSm0znKX3fzzLGf/WQjATUx/8Y23ie7deIdzkHQXDnn2ocx7lqb/0/7klHCRLhC1EAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit REST API with MQ Step 6",
        "title": "ACE Toolkit REST API with MQ Step 6",
        "src": "/tech-academy-apac/static/b0312085e00466ca85bfcc6f2484f9f0/3cbba/2022-06-28_12-32-33.png",
        "srcSet": ["/tech-academy-apac/static/b0312085e00466ca85bfcc6f2484f9f0/7fc1e/2022-06-28_12-32-33.png 288w", "/tech-academy-apac/static/b0312085e00466ca85bfcc6f2484f9f0/a5df1/2022-06-28_12-32-33.png 576w", "/tech-academy-apac/static/b0312085e00466ca85bfcc6f2484f9f0/3cbba/2022-06-28_12-32-33.png 1152w", "/tech-academy-apac/static/b0312085e00466ca85bfcc6f2484f9f0/4c487/2022-06-28_12-32-33.png 1280w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">{`Drag and drop the `}<em parentName="li">{`Nodes`}</em>{` from the palette to implemeng the “logic”. In this case we will use the following nodes:`}</li>
    </ol>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Flow Order Node,`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`HTTP Header Node,`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`MQ Header Node,`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`MQ Output Node, and`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Mapping Node.`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`And you will proceed to wire them. The flow should look like the one below. Once you are done double click the tab again in order to access the properties for each node.
`}</code></pre>
        <span parentName="li" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.94444444444444%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAABpUlEQVQoz5WS607jMBCF8/4PAu8AK34s4gcspVtImgTapm3aXCBuHDtxbpUOY5ewXYRARDqaScbnGztjy5/N8MdxcG7/xYV9h8uZh9F6gaswwG28gRICOc/BOQcvuImF1lt+UA62Y1gGC1jBzMdzmmLf9fC8Rwgq6qddOVDBPVS3h5QSolQoS4mqqlDIivISSinKS1PvuhbhNoZ1P7rCishN22ITRaZjqWrwNDQSZBBFgVYRiKKgHfNCmHUaJCtFJ+Cm0Xa7gTW6uUYSx+j7nkzKFPRCDdWqqxIJ4zizI6jqsDMphYka7j/NTYO6bsBYBmviLzBfrtHWNX5HK2SigCoPUK2KjIwLTJYvkOIfyPwGigvy5pw85M8Yg5XGCThB0O9xGrg4IblZipaOIo6gfTPsTpo4qGnq95xp4Drc4CXLaCgdfq3n2NK0BtNxHODD+0f9B0ySxGxZUUHpbvJz01d6B6YE43lupiyPjvJT6WEa4CqM4biPiOMIu93OXIecGnynj+v0e5bpKTseJg8ObPsB0+mULrf3rVzXxXg8NvH4u+/7eAV+2TvA9tf/bAAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "ACE Toolkit REST API with MQ Step 7",
            "title": "ACE Toolkit REST API with MQ Step 7",
            "src": "/tech-academy-apac/static/a4e1fc09dc4e061500f6ef2f5d2de70f/3cbba/2022-06-28_12-37-45.png",
            "srcSet": ["/tech-academy-apac/static/a4e1fc09dc4e061500f6ef2f5d2de70f/7fc1e/2022-06-28_12-37-45.png 288w", "/tech-academy-apac/static/a4e1fc09dc4e061500f6ef2f5d2de70f/a5df1/2022-06-28_12-37-45.png 576w", "/tech-academy-apac/static/a4e1fc09dc4e061500f6ef2f5d2de70f/3cbba/2022-06-28_12-37-45.png 1152w", "/tech-academy-apac/static/a4e1fc09dc4e061500f6ef2f5d2de70f/4c487/2022-06-28_12-37-45.png 1280w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </li>
    </ul>
    <ol {...{
      "start": 8
    }}>
      <li parentName="ol">{`Now we will configure each node, starting with the `}<em parentName="li">{`HTTP Header Node`}</em>{`. Click on it to bring it to focus and then select the `}<em parentName="li">{`HTTP Input`}</em>{` tab followed by the `}<em parentName="li">{`Delete header`}</em>{` option as shown below.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.94444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB/ElEQVQoz3VS227bMAz1/3/IfmGPe1qBNliQYkCTLm58l+3Ysi3JknxpfEY5adEFmACConlE8vDYi7MCrKjAygJ5WSJlDEVeIiOfFwWUUjBGQxkLYw0s2fDpLeKO43t8xKZMobsOXkxF4pRByB5KEyAK1yLnqsb+8Ip5ntFT3P3+AS0a9MZglzNsswS/WIxHliCpOWTfU2MDbxwHaN3Tw3fMg8H+eYNOSAghkOfFClKS4uwNomupsQTjFdKqxFueQUpFebVieirq4ctxFJ63W0w0ldb6SpWmc8DejlDkJ6vx5J+xTzgWGkZS/gPTNC28y+WCZVmo3IJxvmD7clwncQBJXdXtgVJyfWyJzWvW4JRzGH3FfODatv13Qneq8xnjNK1U3ZTrpM7fYtdootWMJIq7f2CujGiHWjvFLIbRqTjgT1DgTOoyUrnmHLzhqGnpTV1DECW326bt0JKi7t6R7zpBcYvOTZiRSmkcY6AOdhjwQirvfR/+8YSjH5IFSJIcIUtxSCLUTQNLIkgq1FCB9macvrOyvlJObY8HnuOpYvj28BMb/wRrRtqNozHC9BYH+o0ekxA7XiLQAvJ9ut8Whnm5FuwpKeZx/RhFGaqqxf/OvFywayvsRL3Gy13eC4JgpewsDENEcURFo/V+bw4bUy6P6Wcm7+Kv+RPFfwGfBkHQB3ZTZgAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit REST API with MQ Step 8",
        "title": "ACE Toolkit REST API with MQ Step 8",
        "src": "/tech-academy-apac/static/417f5fbbe810717a3fbc417b5d2b578f/3cbba/2022-06-28_12-40-26.png",
        "srcSet": ["/tech-academy-apac/static/417f5fbbe810717a3fbc417b5d2b578f/7fc1e/2022-06-28_12-40-26.png 288w", "/tech-academy-apac/static/417f5fbbe810717a3fbc417b5d2b578f/a5df1/2022-06-28_12-40-26.png 576w", "/tech-academy-apac/static/417f5fbbe810717a3fbc417b5d2b578f/3cbba/2022-06-28_12-40-26.png 1152w", "/tech-academy-apac/static/417f5fbbe810717a3fbc417b5d2b578f/4c487/2022-06-28_12-40-26.png 1280w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 9
    }}>
      <li parentName="ol">{`Now select the `}<em parentName="li">{`MQ Header Node`}</em>{` and navigate to the `}<em parentName="li">{`MQMD`}</em>{` tab enabling the `}<em parentName="li">{`Add header`}</em>{` option. And selecting `}<em parentName="li">{`MQMFT_STRING`}</em>{` for the `}<em parentName="li">{`Format`}</em>{` field as shown below.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.94444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAACKElEQVQoz1VT6W7TQBjM+78GEn8QEjxAhUBFkKqkSomSNImvxLcdX2t7s3bsYbwlgq402sOjb2Z2P88cN4AfxAiTGKZtY2+aiKMEnh8gCAIIIdC2DUQr0cqW6xZKSmS1wAd7i8M51mdNUyPPM8yiNIMfxrioDqq74ujYukicJNi+7HG99qi5L35/QV1mLCpRiYaocWka3B1NPHkn7JMQp4IF+76HpPI4jhh7hc3yEUVZoSxLOgy1uqi49wyURY6S65buGqLm2s/OeD4dsfZPCCaH+G9Iqi8XC3QUaaiuo9JdXdeopYLg3MkaP/YRVk6CXkmKCZ1g4uRZjpl2RkxDXQcs1nvtZCJUdDAVfEXFmAKKIjsvgxWcIZtXzo2X5flbh9NI4hhd12m3N5evl95Cco6rkt8adJdWi06cGybebCJ2SqHvFORFYWeH+nVd10WSphpRnCDjXDDSR3MD75yi4h0XRfEXpXanHYahh7VlIKkKvrTCim1js31814PlHBGxeEmiF3j4ZrxgGZzQsFjOs6L4h6llMj6QjryvCzycQ3wNHHz69YiN7yEmgT0DLy+xCyIsiHu2VNteGLeHaCT664h+II1oOqDj4s0dDsPAKAJPtoW7wwbLMsXn5zXef3/EPRv9IUoxj1MszwUYBkIOxAipRjjZgFxIzCzLhuM4sAnnBka2LQvvFj+x3G3hWiYs7g3DwHyzwvxlDZe86cymuEMYJv+ywwF/APzgPO7z77vEAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit REST API with MQ Step 9",
        "title": "ACE Toolkit REST API with MQ Step 9",
        "src": "/tech-academy-apac/static/b0671e2ccc993db539f82bb2da552505/3cbba/2022-06-28_13-01-52.png",
        "srcSet": ["/tech-academy-apac/static/b0671e2ccc993db539f82bb2da552505/7fc1e/2022-06-28_13-01-52.png 288w", "/tech-academy-apac/static/b0671e2ccc993db539f82bb2da552505/a5df1/2022-06-28_13-01-52.png 576w", "/tech-academy-apac/static/b0671e2ccc993db539f82bb2da552505/3cbba/2022-06-28_13-01-52.png 1152w", "/tech-academy-apac/static/b0671e2ccc993db539f82bb2da552505/4c487/2022-06-28_13-01-52.png 1280w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 10
    }}>
      <li parentName="ol">{`Then select the `}<em parentName="li">{`MQ Output Node`}</em>{` and in the `}<em parentName="li">{`Basic`}</em>{` tab enter the name of the queue we will use to put the messages, in this case `}<em parentName="li">{`CP4I.DEMO.API.Q`}</em></li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.94444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAACAUlEQVQoz4VSyY7bMAz1//9OL8X01PZQoO0YzaBJJpPFS2xLjjdtlrckr5RdoDOYQwk8kKKERz5SXpQwZLxAlnPwywVJliHn5NMUKeMwtoNtW2itYG2LruvQWUvewhJ6u6BtDZq6hpeXNRFe0PUjxusN5ziCEAJ2mCCiDcT+B8VXaKWgtCVijZaIlW5xpWJ1q+GnCQ48w7rg8KZpmqvd73fcpgHb1U80QlL1DqpgECyCMkQgJQYikuSN0sipqJ+d8fV8wm/OsCXSDUvh4ZU5OSvfx0hFjNHQrSXJPUk2KBuJh6cUkshG6iyoCjzEB3TG4HA4oWkEhr6H5zpzAO4YSLK/2UOKhgjbWaabnSNvpMIqLKh7sXRJ0gd6Y4gwCGPUTUMztm87dFbQYsZxnC8NLaP9C3e+jd0cOxJ3p50nuM7snG/h9fNgDR7rHPfxil3AwBkDYxkEVXXdllWFiiQ6r5R8B9exkIKW2cBjLEEQhfjGYvyiJWyjCC/HI7bbI74/beCvd0gjjjTOwLIceV4uuJT/YgKjr8cp5y3zWyxWAh/8RwTsgqox+LQ+4eP6iM8Bx5prpGJEJa8oCZVa4OJG9rQUOS/w3Qx3uwA8r5et3yYo+kpJp/Gia3ypMvzPvCAMEZFMh5Di5+cd9vvDHMeUOxNYfEbi3lAufIUgCN6cT3T+A+r7P/ZTdhsCAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit REST API with MQ Step 10",
        "title": "ACE Toolkit REST API with MQ Step 10",
        "src": "/tech-academy-apac/static/9968c13b3eeec52fab236432d4c1b55f/3cbba/2022-06-28_13-04-48.png",
        "srcSet": ["/tech-academy-apac/static/9968c13b3eeec52fab236432d4c1b55f/7fc1e/2022-06-28_13-04-48.png 288w", "/tech-academy-apac/static/9968c13b3eeec52fab236432d4c1b55f/a5df1/2022-06-28_13-04-48.png 576w", "/tech-academy-apac/static/9968c13b3eeec52fab236432d4c1b55f/3cbba/2022-06-28_13-04-48.png 1152w", "/tech-academy-apac/static/9968c13b3eeec52fab236432d4c1b55f/4c487/2022-06-28_13-04-48.png 1280w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 11
    }}>
      <li parentName="ol">{`In the same `}<em parentName="li">{`MQ Output Node`}</em>{` navigate to the `}<em parentName="li">{`MQ Connection`}</em>{` tab enter the information to connect to the Queue Manager. The information is based on the configuration we used for MQ, and for simplicity is included below.`}</li>
    </ol>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Connection`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><em parentName="strong">{`MQ client connection properties`}</em></strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Destination queue manager name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><em parentName="strong">{`QMGRDEMO`}</em></strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Queue manager host name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><em parentName="strong">{`qmgr-demo-ibm-mq`}</em></strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Listener port number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><em parentName="strong">{`1414`}</em></strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Channel name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><em parentName="strong">{`ACE.TO.MQ`}</em></strong></td>
        </tr>
      </tbody>
    </table>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.94444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAACJklEQVQoz1VSyXacMBDk/78lhxxyyiGHHLI6TmyPB2yGRZhtYFglMcAMLpeYJM/We/1ajVB1VZcsEWdI8xLpPkdeFIjTFPucOUmQZDnUcMSgNaTsMQwaxyPrYWAe/u9HhtYKTV3D2h9qAhY4jjPm84KnSKBtWwzTCa3YonV/cn+G7Hv0ciCwXIE7qaGUYkON2yyFm6ewyxzW6XRauz0/P2M5TbBvrtC0HQZ278sMbSbQK42+6zAZIOae4G0n18YdmTvFHnYS4z6LYeHVMhJurq8xs4lSElIPZDBSssKh6fDxNiGYpLzLCAxbw3K380mixTSOsAwzE2ZNlHy9ddG1DX/Uq0xz0YA3XY+bsCSzDpJ1Z0bQX0CDMELdNOs83zA0qyxKzPO8Hhom/8LU5+lIMIWJzCfW6u/ZNI3ruSFhaX3ESKrrx3HC1k+RZXQ+TXCoKtR0rl2joosNZgL6dYmgKiHJ1szRREOGLZVZKQcZ0VkzJ8MsiVOEfgDPF/A8gYddgA33dzsPTiDwI/DxztlgS2clzavYxIBVbJoVh4vklu5+yAW+7mO8/3WFT7aNbH/gBYmwqnEfBHji00p5eUt2y3wGFjP3t6HG5QK4GEOWM5ZlwfeNA1vElHtY5xTJDnesi04j7hUEm8wnQE0L9PgqWA/jGVYQhIiEoOwIgtl9dOFR3s7z+MgjbFh//n2LbxsbX+62+OO4eHBDOG4A5zG45DVC2I8+XgBgjj8RfJpecQAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit REST API with MQ Step 11",
        "title": "ACE Toolkit REST API with MQ Step 11",
        "src": "/tech-academy-apac/static/a08ac34185ece882909fd32fb1845d3a/3cbba/2022-06-28_13-07-42.png",
        "srcSet": ["/tech-academy-apac/static/a08ac34185ece882909fd32fb1845d3a/7fc1e/2022-06-28_13-07-42.png 288w", "/tech-academy-apac/static/a08ac34185ece882909fd32fb1845d3a/a5df1/2022-06-28_13-07-42.png 576w", "/tech-academy-apac/static/a08ac34185ece882909fd32fb1845d3a/3cbba/2022-06-28_13-07-42.png 1152w", "/tech-academy-apac/static/a08ac34185ece882909fd32fb1845d3a/4c487/2022-06-28_13-07-42.png 1280w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 12
    }}>
      <li parentName="ol">{`Now double click the `}<em parentName="li">{`Mapping Node`}</em>{`,`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.94444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAABw0lEQVQoz4VS227bMAz1/39Df2J/sKe+FAECrN7cizPbWyU5cW3JkiVf4pyRalIE6cMIHFCkeCeTP0JBqj1EraD2ezzlOSTp6rqOcqt7dF2LpmmId9BGQ2sNwzi/NenZRkqJRDXvEBRwnGZMy4qqLKKRJ1kXKfTLA72P6PsevfNw1sL7AcYOsM4hBA/TOzg3IHiP5LgsUXk6nbAuE35uH9BpAx8C+oOEliV6cu6NwUiBOkrGwbWxVJWGpQR28CQb0hskuCLOsN1ssFAS5z4MrQ+YKNDu0ODu/heeqK1HJdBRAOdcxMtrHrsKVETClTGYuOVN+kzz6eAGasn2sYKBnL5XO3z78YpMvCGrRawoVkf4XVRxvp5bxg0daBHzPGOggJyduSEnRUnWyX/ozpVdMI4h2nHwZBgCKUZM04gwTthmBfJ8h7IsIYSEoBYl8Zr4G3Pa/i2UUnHDcctC/kVZlZTBwY8zHp8LlEXxadS2bZxPPJnzQm7BlfE58Rkll/kxreuKfFehee/i5rkdG8/Ex794CcRvwfqFxuT89HWG3PZEnxfn64T/o+MKJGmaxnldUFXVF1z/R9BIsixDQfxTx3Yk/wP6wUVApzi0lAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit REST API with MQ Step 12",
        "title": "ACE Toolkit REST API with MQ Step 12",
        "src": "/tech-academy-apac/static/f971fcc51bb51341ed85a5cd6b7c17bc/3cbba/2022-06-28_13-08-43.png",
        "srcSet": ["/tech-academy-apac/static/f971fcc51bb51341ed85a5cd6b7c17bc/7fc1e/2022-06-28_13-08-43.png 288w", "/tech-academy-apac/static/f971fcc51bb51341ed85a5cd6b7c17bc/a5df1/2022-06-28_13-08-43.png 576w", "/tech-academy-apac/static/f971fcc51bb51341ed85a5cd6b7c17bc/3cbba/2022-06-28_13-08-43.png 1152w", "/tech-academy-apac/static/f971fcc51bb51341ed85a5cd6b7c17bc/4c487/2022-06-28_13-08-43.png 1280w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 13
    }}>
      <li parentName="ol">{`In the wizard window simply click `}<em parentName="li">{`Finish`}</em>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "813px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "64.2361111111111%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAABoUlEQVQ4y53TSW7bMBQGYN611+i6R+mmi66zKboK0KSxYdlOZMUVLVGcKVlD7ATx4g8pV0IRuHFaAR8ocXji8Eg4pxC1Qdu02NZ1b7ff9/aPjzDGIMtzUEphrcVut0P38HBS03UgQkiwnPlBGdI0RVEUaNu21/kOIcDhcMC5Z/v8DP30BKKNBeccUsqRcw5VVaEsy/G9aZrxR6fUge9DFkmG6+ufmE6nmEyOZrMI8/kcy+USq1WCOF4hSRIwxt4kuABhfon3vvMmXSOjv5BtUo/2CpZDCj5SUpzAIYToV6mUAsmzDXKucM8qrIsKKd9C2rYnAtO8qdA1rDtuT0DiZI2ryQIXl3f4fpPiMtqAqe2o+IuhLZd+Asr4bNCeBZneUkSzGeg6QeaXLYocWsl/EpY6HCjp98FXhOhaGyit+zLk33u87kucO6bG/2rLCs46GJ/01n+TUBluwJ9cz41et9vf7SHID0bhSouuKlGHQ9F+mqcGnOUsah/083KCr3GMq5ThJmM+bQp+dvBwY4ZyuD1GaZ9aCh8vInz4ssCnbxFeALGSxhmmGt/WAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit REST API with MQ Step 13",
        "title": "ACE Toolkit REST API with MQ Step 13",
        "src": "/tech-academy-apac/static/499062c7b7b97cfc39affb21d61fee3d/25f8d/2022-06-28_13-09-14.png",
        "srcSet": ["/tech-academy-apac/static/499062c7b7b97cfc39affb21d61fee3d/7fc1e/2022-06-28_13-09-14.png 288w", "/tech-academy-apac/static/499062c7b7b97cfc39affb21d61fee3d/a5df1/2022-06-28_13-09-14.png 576w", "/tech-academy-apac/static/499062c7b7b97cfc39affb21d61fee3d/25f8d/2022-06-28_13-09-14.png 813w"],
        "sizes": "(max-width: 813px) 100vw, 813px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 14
    }}>
      <li parentName="ol">{`Expand the `}<em parentName="li">{`JSON`}</em>{` section in both the input and output message assemblies and connect the `}<em parentName="li">{`payload`}</em>{` as shown below.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.94444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAABx0lEQVQoz52SyW7jMAyG/f4vNMfe5thiAhRJM05ieZMl21pseV/+0k6RSW/FCPhALdQvkqLHYo4kFUhFBi4EfJaAMY6/1xBRKiFyTfslnZdk1d1KBVlaZNsZzZMsJwp8+Fd4Qlu6VGIcZ0wrEMYpjscTskxCForOFHSh0bUdbFWiqixUmSNkDJbuNrWDsRW6foDrenjaVDiT8ua4DCN4RlH6Poo8B+d8x1qDeZlRNy3GeYZrHE6nM96CC44RQxyFmIcBoIC8umngBwHklq7KcSLBkiLruhaC9pRSmOih5zHPyx75TRf4ffPxcvnAHy1xrS289cvppUxxMAUyXSISCVRVIBERSpPDdBYnneM1ljgrjWZqIcnW1qKQAobuJM7gtRDwHq8uy26nacI0j8SEcdoiW3FxGr94AE7ZvKsCrKZaOgtDIrpSZDX5LfeUm6ZD3/cYhn4vrDI1nGvRdsM3Zkr7zkT+4z+GOw19iKkcvJTHYCEjEUeiA4KAUduEe/2EpJ8mtnmWZVBa009XO9UXltLerDFmx1vX9VHsbX44HBCG0Z76OI7f+MnwnheboO9fkKYc/zu8G7UMY+xBFEUIqa+e935KQFqfaZVE0KcU5nUAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit REST API with MQ Step 14",
        "title": "ACE Toolkit REST API with MQ Step 14",
        "src": "/tech-academy-apac/static/197d75bf4f8b85f219362ac795961bcf/3cbba/2022-06-28_13-11-15.png",
        "srcSet": ["/tech-academy-apac/static/197d75bf4f8b85f219362ac795961bcf/7fc1e/2022-06-28_13-11-15.png 288w", "/tech-academy-apac/static/197d75bf4f8b85f219362ac795961bcf/a5df1/2022-06-28_13-11-15.png 576w", "/tech-academy-apac/static/197d75bf4f8b85f219362ac795961bcf/3cbba/2022-06-28_13-11-15.png 1152w", "/tech-academy-apac/static/197d75bf4f8b85f219362ac795961bcf/4c487/2022-06-28_13-11-15.png 1280w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 15
    }}>
      <li parentName="ol">{`Then `}<em parentName="li">{`right click`}</em>{` the `}<em parentName="li">{`code`}</em>{` field and select `}<em parentName="li">{`Add Assign`}</em>{` from the menu.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.94444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAACH0lEQVQoz2VTyY7TQBT0t3PhBJ/BgSsICdBwGaFhRkFM4pDV+9pe2/s+KV63NIMClipt9/Mr16vqKK7PELAIQcQQRhE024ftMJwNB24QI0o41bK/YKmEL1Z6ZlQP4xwhy6DrFpSIl9SUYZoXzBfA8QLs9wcwFiNOc2rIwMsaaZrCsh34IYMfhPAIIQnhZYWK6nnXgdUNFF5UOGkGqqrEMPSyQdM1pEkCFlJTGKCua2Q5KTAMuJ4n4bguPELMQiRBgK++AZWnUOq2hW5ZiBhD3/dIcqE4RS++SHtZJtRP4JzDIEKfmp8JTd+DTve32hE/kxCgCRX8c5UkW1jQdS2SNEFD6sTF4ggPqxXU7Rb7wwGObWNjGvj0+Auf1Q2MPMWyPF0TXi4X6aVYBegH49MCd+pQkcL1Zo3T+QzHcWCTwohCHGiSZRpl/zQTYdt25N2AcRxoHZEXNRraa7ueVA7gTYMPtobvpg5V3ZK/+svYjAj7YSKM8v2ybqEEoUfHxCaShkhHGKYFm9LM85yCyMFzjqmu8P5xi1cfV3h7c8SbmzNefznj3cORQvMQxwmKogAvuBj5cuWhUCuKLYU1z7OE9JDUfPtxh/XpiB15t9HOFIgr68uyyEDFafgvFBlMWcpUnwmFn0LFkcIIfF8eJ7HG9BFBJiCma8gexbTEiPYLLHoWPmmaBtM0JcTebr/H3f09Nqoq73/vdvQH2F+9I47VHxy0NbcYfKgLAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit REST API with MQ Step 15",
        "title": "ACE Toolkit REST API with MQ Step 15",
        "src": "/tech-academy-apac/static/c5545ddb4888fcf2812448ab7e5f1e14/3cbba/2022-06-28_14-45-30.png",
        "srcSet": ["/tech-academy-apac/static/c5545ddb4888fcf2812448ab7e5f1e14/7fc1e/2022-06-28_14-45-30.png 288w", "/tech-academy-apac/static/c5545ddb4888fcf2812448ab7e5f1e14/a5df1/2022-06-28_14-45-30.png 576w", "/tech-academy-apac/static/c5545ddb4888fcf2812448ab7e5f1e14/3cbba/2022-06-28_14-45-30.png 1152w", "/tech-academy-apac/static/c5545ddb4888fcf2812448ab7e5f1e14/4c487/2022-06-28_14-45-30.png 1280w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 16
    }}>
      <li parentName="ol">{`In the properties section enter `}<strong parentName="li"><em parentName="strong">{`CP4I0000`}</em></strong>{` in the `}<em parentName="li">{`value`}</em>{` field.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.94444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAABzElEQVQoz31S2Y7cIBCc//+YKB+x2jxt8jjWHDs+B4NtbDD4xK40aDfKzihBKjX0UdBFH5Kc4c4E7rwE4xx30YBXHZ0b1G0fbFqIYKWyaDoTrOpHdASpDGqpKVdTfYUDbxURNFiWFW4H8oLheIxQcgHRSPBaou007DhCqQZaK8imQpokqCmudY9OaUzTjIUIDj75dHkPidM04V5yXC4X1FWFkjEwglId9n3DQKTOOVhrcYxOENSRz8mylGopthFhT8FrHIOXJUYq8E/nVY1xGFCST0qJeZ6xUfI4OyzrhnmdUQhBFxiIigc4t2J1Gw54WNrYIMFAF1V1hb7vQ/KyOiIxaNRIrU0oaiKSAkWZkSws+Nb1gXDf91Do7ef5X8sMY3j5QJ14/fwKLVs7BO3meQoBbQb09MpeG1jaW9p74duuDeIbyvc1dvgKQx35+OHOciRpQg4TCNMsA8tzvEYRvr39wve3n3iJzvT7IoxPUcoHNMHmZDNW+5b3Ly0foytp10FSS3HTIpcK107hB32CXUgSB/qUZ3j/RPEnDU/nhEanedJs2RzN6Yb/LyK80cgkNKSfOJ3OYQ5j8t/+QvoR9/44Tj4Q/4GP3W43/AbrmEb2Wm3ooAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit REST API with MQ Step 16",
        "title": "ACE Toolkit REST API with MQ Step 16",
        "src": "/tech-academy-apac/static/fafd31a6e25fbafabcd613a458dc728f/3cbba/2022-06-28_14-46-24.png",
        "srcSet": ["/tech-academy-apac/static/fafd31a6e25fbafabcd613a458dc728f/7fc1e/2022-06-28_14-46-24.png 288w", "/tech-academy-apac/static/fafd31a6e25fbafabcd613a458dc728f/a5df1/2022-06-28_14-46-24.png 576w", "/tech-academy-apac/static/fafd31a6e25fbafabcd613a458dc728f/3cbba/2022-06-28_14-46-24.png 1152w", "/tech-academy-apac/static/fafd31a6e25fbafabcd613a458dc728f/4c487/2022-06-28_14-46-24.png 1280w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 17
    }}>
      <li parentName="ol">
        <p parentName="li">{`Repeat the same process for field `}<em parentName="p">{`msg`}</em>{` and assign the value `}<strong parentName="p"><em parentName="strong">{`Request has been processed`}</em></strong></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Do the same for field `}<em parentName="p">{`time`}</em>{` but this time we will replace the `}<em parentName="p">{`Assign`}</em>{` option with the `}<em parentName="p">{`current-time`}</em>{` function as shown below.`}</p>
      </li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.94444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAACD0lEQVQoz22SiY7TQBBE/f9fwI+gFUgoEgIhxEIEWeIcThw7iW97fMbx+WgHLSKwLZXG4+rprq4ZzT45nF0fx/dwfR/DOmPZHtu9zdEJ8COFGyTCxYJE8uLbPogz4VK8iROcvIi1sUfzlRBhTNv1dCNMDXR9hecFBFEiXIKSovWlJssT8jwliUNsyyKMp32BSjO6tqNvOjSV5mykcp5nXK+1qPUwdgZRGOK5Lq4gy1LGcaCUom3fU1Yly9UaX6ZyXAfneOQsjVZFilZUFbvDAd/zqOuaMJkUR6LoIio9VJLQNg2I+gmjoO8HIlHdNy2p8JUofIw9FqJc45/IivJmwUUaRVFEmudcu5a667CinOLSEtcFM0Pno7ni/WbBw2rOg7WGgfuCo7SfvJzWQUacYldmvPVtvoYus43Bq8+f+CCWfNsdmJsWy6PFSQXkzYWmG9Cq6iLeXWmaq6wNiXhalBWV+DV5VlY1U04mit+5No/mge9PS0K51a4daOqGrunlbCvTVWiOe5JnYt2MbsQry7IF1m1cpeRGlSKT9RwFfHFsrmLJYvkTfb2iljOVeK0kR6WKNE2nkce7kdcbEz9Qt++XwlUJbxZzXus/OFW5+DbSD8Of8/95uN3Ztwf8UkwtOrmc59yZf0TP4rsczZQnM434jO3WwDB2d//+hmmawhtYexN9u+FJcLR/23SQWr8AjvE/NWaOHrgAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit REST API with MQ Step 18",
        "title": "ACE Toolkit REST API with MQ Step 18",
        "src": "/tech-academy-apac/static/458671fafcf376f65986156b475681ba/3cbba/2022-06-28_14-47-50.png",
        "srcSet": ["/tech-academy-apac/static/458671fafcf376f65986156b475681ba/7fc1e/2022-06-28_14-47-50.png 288w", "/tech-academy-apac/static/458671fafcf376f65986156b475681ba/a5df1/2022-06-28_14-47-50.png 576w", "/tech-academy-apac/static/458671fafcf376f65986156b475681ba/3cbba/2022-06-28_14-47-50.png 1152w", "/tech-academy-apac/static/458671fafcf376f65986156b475681ba/4c487/2022-06-28_14-47-50.png 1280w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 19
    }}>
      <li parentName="ol">{`The integration flow is completed. Save your progress and close the `}<em parentName="li">{`mapping`}</em>{` tab.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.94444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB70lEQVQoz3WS2Y7TQBBF/f/fA09IvCDgjQcQJHEiO97bW3tfOrFzKBsYMczQ0lF1q13lW7facoOYt4fvnOKAIs85eyGerzg7PkGckeYVcVry0XH4GkSUeU0i57SoyQQl90mmiVWBfXGxyqbDUymfi4RxhTCK+XE4olQmCVoSNFVZYaaRT5HDl9hD1yVxGKKynKbtqJuWYZyEGauoGkLX5713xtY5eSoqL5ddrUoSEqFpGpZlYZlvfFABp1bjOS5X3yPPMzzPk29q7suK1Q0Dl+uVIs0w80yua2mzYBpHUanQWmPMDA+erVw3tF1P13Wk0uHN3DC3Oxb/rEY+SvOScRwoimJPWNeFWtqxkwInqxjlB2WjSYpMCqdEKmQyw8uCj8eD233Z48a6rqyPX9Js8fHNN5t3Rxc1iGdTT903dGNL3VXcV7PnWsMwMUurW1vzbMTwlq4fGKeZXoze6IZRFE9iieEuKra7Sfyczf2JcTLS3YAVJ9sz8eiHXooaMdjfTQ5lilVV/6aiEi+1xG1AG23byoSbnW1f1TW1YP3t9taefb4ShCnHw4GDcDweOZ1OO7ZtP+37vue19cLDixPgBQpfVAdBQBRFe9wUBzKUa1xKzGSq5vWCV3kyW4t/OJ8vO67r7kX+h+/7z/K281brJxCGP8pUXfGBAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit REST API with MQ Step 19",
        "title": "ACE Toolkit REST API with MQ Step 19",
        "src": "/tech-academy-apac/static/43f8921e162838ef616a495875384d2a/3cbba/2022-06-28_14-48-57.png",
        "srcSet": ["/tech-academy-apac/static/43f8921e162838ef616a495875384d2a/7fc1e/2022-06-28_14-48-57.png 288w", "/tech-academy-apac/static/43f8921e162838ef616a495875384d2a/a5df1/2022-06-28_14-48-57.png 576w", "/tech-academy-apac/static/43f8921e162838ef616a495875384d2a/3cbba/2022-06-28_14-48-57.png 1152w", "/tech-academy-apac/static/43f8921e162838ef616a495875384d2a/4c487/2022-06-28_14-48-57.png 1280w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <hr></hr>
    <h2>{`2 - Generate the BAR file`}</h2>
    <ol>
      <li parentName="ol">{`Now we will generate the BAR file that we will use to deploy the Integration into CP4I. From the `}<em parentName="li">{`File`}</em>{` menu select `}<em parentName="li">{`New`}</em>{` and then `}<em parentName="li">{`BAR file`}</em>{` as shown below.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.94444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAACB0lEQVQoz3VTyY7TQBT0/0vc+QROIy5ckDhwASISi2QSO4mzeHfbjvcltmeSotrgESOgpVK723n1quo5iuMJ+CKEiELonoP36gyb9RqO68ImRBjCdhwsVyuYto0wingnkGcZ8jwnshFpmiIQARSRFQjjBP3TMz4ENjRjB9uyWRTBD8RIeDyd8GP+BQbfjYTRBWVZoWlqVHWDoqpxvbY8N1CyvMT+cERVVaiLDNpqgZNpsZsYIUhwNk9YLeeYL+YwDgekSYKmKlEUBQoSZ3nBBuXIoVRkPZgmYhZKG+r8O5UFozIJqchxPGw0HWfLQhJHmO0c6M4FQ3dFSZJRTF0jSVIo+GMNtzsWmoGDYeB0Nn8RM1vT8qCqy9F6mlygmT5MkaClZWl9UidzfEUol+v6MI4nRFQWUGESxzgy089Uvlw/wvN9ksa4tjK/elQ2QWaqNE2LruvQ9x3arsdSP0PTdVhyopy+FXh4p67w5uMj3n7a42GW4qseIwoDhDKS35ATDuhI8QOXxRY7VBiGJ9ol4XYL4XlYWGc87NeY6Rq+qQvsOJCIimWuk81pz+WACFq+v9i93+/MIUPG4VT8YTv06J+f0fJ5s1mPE5aW48sFt9vtFWSt3P/KUC75YhiGl3PdNnA9l41yJAy+YIP/LcXkJ2Pxc5gwnW1mON3JZ4f/FrlP91vG8q/an/ViNUm3OcLJAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit REST API with MQ Step 20",
        "title": "ACE Toolkit REST API with MQ Step 20",
        "src": "/tech-academy-apac/static/01c682eda0986493e903c9e06fc8c951/3cbba/2022-06-28_14-50-45.png",
        "srcSet": ["/tech-academy-apac/static/01c682eda0986493e903c9e06fc8c951/7fc1e/2022-06-28_14-50-45.png 288w", "/tech-academy-apac/static/01c682eda0986493e903c9e06fc8c951/a5df1/2022-06-28_14-50-45.png 576w", "/tech-academy-apac/static/01c682eda0986493e903c9e06fc8c951/3cbba/2022-06-28_14-50-45.png 1152w", "/tech-academy-apac/static/01c682eda0986493e903c9e06fc8c951/4c487/2022-06-28_14-50-45.png 1280w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`In the pop up window enter the name of the BAR file, in this case `}<strong parentName="li"><em parentName="strong">{`CP4IACEMQAPIPREM`}</em></strong>{`. And then click `}<em parentName="li">{`Finish`}</em>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "590px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "84.72222222222221%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAYAAADdRIy+AAAACXBIWXMAAAsTAAALEwEAmpwYAAACZklEQVQ4y5WU207bQBCG/Zx9EapeILXiBdrL9oYLEG1foEhVKRQBUWloSCEhJA5OHJ/24NM6oSRN/s5umhBQANXS5x3bO7/nH+/aUlcO2tKBUDFUrpDlOVRRIMsy5ErBDwI0Li8NAcX6XkrP7pPlmcmxPM9DvV5Hs9lEtVo1Y0GCo9EI+phMJobFeBE6YTSe4Cr9Az4Yw7q5uUGSJEjTFHEcm1hKieFwaBLG4/Gj6EMLtkgw6pNgFEXwfR96DMMQiiz1iz6Vn0+tPAEXwhSQUUEpFWPZto1Go4Fut4PaRQ1ccuRFjkLl6BNKZRQ/TCwFeq6LXq9nHFp2q4V628bWaRXvvuxho3SM99/L5tqJFURyjSgegC1DP5N9hBFDRO50pVbg+bjyXHysnGHrqIKNgzI2D06wXirjzJXo+DlsL0P7QVIwrm0LcM5hpVRmM/Dx8mQPTtCDG3ro0BhEARLBIQUj+KMIQosJ6qelZIzTXgdvz37gd5LSTUl9kTRR0iTx31j9OMH6ZRWbzV8YUBxxZt425X7CbSWMRvYvXpxrDajCZ6VtrPz8hmsSZA+KTZkJFJSXSzl/wVxQfxm9W/RanNrkT9jiSGnejtvGoeeY+E6F+kKLyiVvWyYWEdqJdvWiso8h9T2au+JTwcXezGzNmdkUtz3UH812u/hwcQpf53Fpls7Ust46C5MfY9Y/XdGItuZaeR9fnRrFHEnsI5OM/jZ+AI1eS+wJQcaYaU1EIwtCOMzH6m4Fr3YusPq5jjfH57A6XZf+eaFZ6XesLsHYpY2ghUPKYYnA2m4Nz7dbWPlk4/XhOf4CDJXv9PXxuMAAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit REST API with MQ Step 21",
        "title": "ACE Toolkit REST API with MQ Step 21",
        "src": "/tech-academy-apac/static/cbeb79435bce0eda69096e300153d2d9/102e5/2022-06-28_14-52-42.png",
        "srcSet": ["/tech-academy-apac/static/cbeb79435bce0eda69096e300153d2d9/7fc1e/2022-06-28_14-52-42.png 288w", "/tech-academy-apac/static/cbeb79435bce0eda69096e300153d2d9/a5df1/2022-06-28_14-52-42.png 576w", "/tech-academy-apac/static/cbeb79435bce0eda69096e300153d2d9/102e5/2022-06-28_14-52-42.png 590w"],
        "sizes": "(max-width: 590px) 100vw, 590px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Click `}<em parentName="li">{`OK`}</em>{` in the confirmation window.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "550px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "37.84722222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsTAAALEwEAmpwYAAABUklEQVQoz4WRW0vDQBCF89d981f4EyyCPii2giAiWJvWJE3SJr3mttckFX08zi5NW0Hx4ePMHM4Ou7POvEwxUyk+dh+omxpN21jaXYskTeCOXcRxDM/3EEYhdK2htYbSitAHOs/JyxJBOEUUzzCbJ5hOQ9I59THCMEKW5yjKylISjHEw/gt735FVDlkVEEZZAV5mEOzYt1r8oFH8T7SkgbfvGg/TGgNDUNu6T3ofaNv3ff0vA8reeRrDhJ6cZhKLTBxIiU1B+2EtlrnEMttDdXqSW1B/xJyT2JQCjrlmhxQcn7TYx0WE88kTClGBk18RTDI0UthcrQQUacfpeYfTIjkXFrNUJc1Ntjh77uPCf8NN7OPSG6EXexjlGyjKbbMMSilIykpSM8PWhCOEsIbRrq6lwpeucR2MceW+ojd8QW8yhLtd0QcyrNZrm+2GMMasGu8bicdLLCPKD6gAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit REST API with MQ Step 22",
        "title": "ACE Toolkit REST API with MQ Step 22",
        "src": "/tech-academy-apac/static/e058b58b9678f824e2fc04d10a5acde7/50322/2022-06-28_14-54-12.png",
        "srcSet": ["/tech-academy-apac/static/e058b58b9678f824e2fc04d10a5acde7/7fc1e/2022-06-28_14-54-12.png 288w", "/tech-academy-apac/static/e058b58b9678f824e2fc04d10a5acde7/50322/2022-06-28_14-54-12.png 550w"],
        "sizes": "(max-width: 550px) 100vw, 550px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`The `}<strong parentName="li"><em parentName="strong">{`BAR Editor`}</em></strong>{` is open. Select `}<strong parentName="li"><em parentName="strong">{`Applications, shared libraries, services, REST APIs, and Test Projects`}</em></strong>{` to display the right type of resources and then select your application, in this case `}<strong parentName="li"><em parentName="strong">{`MQAPI`}</em></strong>{`. Finally click `}<strong parentName="li"><em parentName="strong">{`Build and Save…`}</em></strong>{` to create the BAR file.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "37.84722222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAo0lEQVQoz52SbQuDIBhF/f//sG3tk4uVK1vWo+bLzQqCQQRTOFy84kHkYR/ZQw4KkzYwswORhtYaxlhok7oT9t5iaAQ6XkF9B1C6s/asvhcQ5QP1rUD/4qCJYK2F9yHhL9GywygE3rVAVSWxGsEazjFKCdW2mImQu2KMWzLxLNfdz8F/hEO2JovBI4aQITqHxaxXXQiv/iRLeIzCNip7OueypQu96HXm6M+E3wAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 31",
        "title": "ACE Toolkit integration with ES Configuration Step 31",
        "src": "/tech-academy-apac/static/09dda0ddc22c257a15b56cc98aed1e90/3cbba/bar-build.png",
        "srcSet": ["/tech-academy-apac/static/09dda0ddc22c257a15b56cc98aed1e90/7fc1e/bar-build.png 288w", "/tech-academy-apac/static/09dda0ddc22c257a15b56cc98aed1e90/a5df1/bar-build.png 576w", "/tech-academy-apac/static/09dda0ddc22c257a15b56cc98aed1e90/3cbba/bar-build.png 1152w", "/tech-academy-apac/static/09dda0ddc22c257a15b56cc98aed1e90/0b124/bar-build.png 1728w", "/tech-academy-apac/static/09dda0ddc22c257a15b56cc98aed1e90/4ea69/bar-build.png 2304w", "/tech-academy-apac/static/09dda0ddc22c257a15b56cc98aed1e90/81fbf/bar-build.png 4074w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`You can dismiss the notification window reporting the result clicking `}<strong parentName="li"><em parentName="strong">{`OK`}</em></strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "550px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "37.84722222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsTAAALEwEAmpwYAAABRklEQVQoz33R2UrDQBQG4Lyrr+S1zyCtIC2tCiIiWKw0SdMsbUzMOmuTev17MjWhuF18/DPJOQdmxgqKEIGM8NEeoBuFpt1j32iTu3gL214h2oZYey6C0IfS8l9WVhZwNx58P0AYRdToUWOEDe29jY8sz1GUFSlNVnVN2K9qYilWoCPr3KSocsiTfav5keqxH5qv1JIGTmyF27XGTcc95sxVRGNOZo4azP9C9VOas4joyOG7QJTxQZgJ5KVGWWjsaB3nEnEmTW6zrravFwPzneYkBacjC4aOJK2kn0WK89UjJomPnJVI6QrSuiA5+lot+bA+JTkdmTEGxjiOycA5x72/xtndGBfOAlPfxch5xaVv4yHdQXNhHkpKCSGE0fX3a6sb8N1BKfCqwthZ4tpe4mr5jJH9gqc4osdieEsSU9cPqenl+95PpxRKvJg4ragAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 32",
        "title": "ACE Toolkit integration with ES Configuration Step 32",
        "src": "/tech-academy-apac/static/7e1867e788d1343161d026f40359b9c0/50322/2021-09-19_08-11-35.png",
        "srcSet": ["/tech-academy-apac/static/7e1867e788d1343161d026f40359b9c0/7fc1e/2021-09-19_08-11-35.png 288w", "/tech-academy-apac/static/7e1867e788d1343161d026f40359b9c0/50322/2021-09-19_08-11-35.png 550w"],
        "sizes": "(max-width: 550px) 100vw, 550px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <hr></hr>
    <h2>{`3 - Deploy BAR file using ACE Dashboard`}</h2>
    <ol>
      <li parentName="ol">{`Back to Platform Navigator, open the `}<strong parentName="li">{`ACE Dashboard`}</strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABsklEQVQoz3WSTY7UMBCF+wBIqJk4sR3np5PY+fN0p5u0RrNhYIXEhjMgseQInIBLP6pKJKNZsHiyXe189V65D3meg1UUhcg5hyzL/qMUmS2QqSP08R3SNEWqPpCOyLSGLUscpEgq6VBVlUCVUiKub6sAtYFyA5L1Bx6+/4YzKVz4Au0/E/RB7h627iEEgXJxHEe0bbvXg/eyTzONymmo51+ovv3BGl8Q5q84P/2EMTmssa9AhnFcTdbZpTFG4MZamNxCJQmdE+RFhbLIKfJ7AtCIrENXUdMmYvTLK5Djiot/I6jrGg25LHJqMvWoei+NcoLzzE+nVu4URSkyNA7WYZuPp1h8kV1ZcjfNj5jjI/quQxsnhE8vaK8fEYYBXdthva9Y1xV936Npmt3IG6CleBKTgAzrfEDHQHLqp5k0EawldyfEGHE+n+X3uj7t/4Q9Mnfi2Emi4MjpMN/QhQk9PQo3G8eZ9r3A2dEwRXg5NxJ9B25WGcaPsjmc4gX9MO2A6/WKZVkwcGRydblccL/fZeXzHpk/ZvErc2R+ZV754kJi5+yQQdt+i3y73aQJ14zRwvkLwAYSDvb975EAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 19",
        "title": "ACE Toolkit integration with ES Configuration Step 19",
        "src": "/tech-academy-apac/static/1c54480e4bd8eb82c171944e3cb48e64/3cbba/2021-09-18_13-19-50.png",
        "srcSet": ["/tech-academy-apac/static/1c54480e4bd8eb82c171944e3cb48e64/7fc1e/2021-09-18_13-19-50.png 288w", "/tech-academy-apac/static/1c54480e4bd8eb82c171944e3cb48e64/a5df1/2021-09-18_13-19-50.png 576w", "/tech-academy-apac/static/1c54480e4bd8eb82c171944e3cb48e64/3cbba/2021-09-18_13-19-50.png 1152w", "/tech-academy-apac/static/1c54480e4bd8eb82c171944e3cb48e64/0b124/2021-09-18_13-19-50.png 1728w", "/tech-academy-apac/static/1c54480e4bd8eb82c171944e3cb48e64/277bd/2021-09-18_13-19-50.png 1919w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`To deploy a BAR file, you need to create an Integration server. Let’s do it! Click `}<strong parentName="li">{`Create a server`}</strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "42.708333333333336%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAIAAAC9o5sfAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA90lEQVQoz42QYU+DMBCG+dEKZiQE9//8aoIu2zJdHFDa4l1bykbxjqnT6KZPmmt77fvetdF8fjubpVmW5XmepulNklx/I47j0+bqY5EkCV2OhnHcbF+EVGCs67zv+/E8YRqfRGBwuVoL0TRSUqBJa91qvSvF43JzV5RPz9tdWbdty3kO71AmIgMEckAeEwDgu654WNwXi1p3VVUprfE3WEwmgAZYTj5wPJATzuLX5A9xGEDURkkjGypqLBfHUxd4Aa5MTZIFTXtnh8A/EkKw1sJl6VEM1tGfh8PeITjvw0AOwTn3D/GhfxUVSuGaGpXi1xtjGYN/8QYS4uYpQGGx+AAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ace mq create server",
        "title": "ace mq create server",
        "src": "/tech-academy-apac/static/4fee9f99727c9338a34cc7ddd66bb1c3/3cbba/ace-mq-create-server.png",
        "srcSet": ["/tech-academy-apac/static/4fee9f99727c9338a34cc7ddd66bb1c3/7fc1e/ace-mq-create-server.png 288w", "/tech-academy-apac/static/4fee9f99727c9338a34cc7ddd66bb1c3/a5df1/ace-mq-create-server.png 576w", "/tech-academy-apac/static/4fee9f99727c9338a34cc7ddd66bb1c3/3cbba/ace-mq-create-server.png 1152w", "/tech-academy-apac/static/4fee9f99727c9338a34cc7ddd66bb1c3/0b124/ace-mq-create-server.png 1728w", "/tech-academy-apac/static/4fee9f99727c9338a34cc7ddd66bb1c3/4ea69/ace-mq-create-server.png 2304w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`This will start the deployment wizard. Select the `}<strong parentName="li">{`Small Integration`}</strong>{` tile and then click the `}<strong parentName="li">{`Next`}</strong>{` button.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "49.30555555555556%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAAByUlEQVQoz3VS227TQBD1LydxoC8NRWq/gsc+8IS4pBJUxUHigY9AKo3r2HVs78Xrexx8mNnEERJlpeNZe2bPnDNr5+XZGWYzF5PJBK7rYj6fU5zRt38xnU5tfrFYEF4RznFx7uLy4gUur17DW63gaFNCKANjDIqiQFGW6Pvf+N/iGs9b4at3h2/eD7y/Fbj+YnD7XUCnKZwgfMKvdYD12ofvEx5DRFsFnRvk5gjaa60tWRiGuFneYLn8SPEObz/5ePPuER8+r5FQzpEqJ3UFlFIEDSUFjBIotIJhSN5rlFVlCSuKwzBYtQPIyVDRjjA0yISAI+gRxzGSJEFekJo0Q/jzHrG/gYy2EGGMzA9sQyZsmgZ1XdO7hJSKGtTU7ICMLXOSC3mG/X6PpqigUrJclGi7Hl2/h96S6jy3NV3X0Yx7q5TH0LYtdrudjVmWwWGyPRHZQoq7qoERylpq2+ZwEamwh7iOIy8WwtaZiBc3SVkhWynpZrkjz6mmCwgfAlJdI9lmpKyCCCLrgg+zSiaWUp7eeQwsyBIyGWMcuCEbKopodiHFJ4jNhuaaHhoea8bak5Ajx8ny37DJukJV11bxGMd/dKx57hwT/gGE99ySaL5dNQAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "small",
        "title": "small",
        "src": "/tech-academy-apac/static/c3ff37cae590beb085358690fd63b2ce/3cbba/small.png",
        "srcSet": ["/tech-academy-apac/static/c3ff37cae590beb085358690fd63b2ce/7fc1e/small.png 288w", "/tech-academy-apac/static/c3ff37cae590beb085358690fd63b2ce/a5df1/small.png 576w", "/tech-academy-apac/static/c3ff37cae590beb085358690fd63b2ce/3cbba/small.png 1152w", "/tech-academy-apac/static/c3ff37cae590beb085358690fd63b2ce/0b124/small.png 1728w", "/tech-academy-apac/static/c3ff37cae590beb085358690fd63b2ce/4ea69/small.png 2304w", "/tech-academy-apac/static/c3ff37cae590beb085358690fd63b2ce/9959f/small.png 3284w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Click to upload your BAR File. And select the `}<strong parentName="li">{`MQAPI.bar`}</strong>{`. And click `}<strong parentName="li">{`Next`}</strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "45.833333333333336%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAABYlAAAWJQFJUiTwAAABUklEQVQoz42QbUvCUBSA94OFcLpqREoEfoz6EQX1sdKy6O0XCBKZRW++rKy9323NanvaJMVKwQMPHM699znnXCmTybC4qJLNysiyTD6voCh5crncRNI7qqpSLBZZLhQpLM2zos6xWlhgY30NqVQqEX7EGKaNcB2EEHh+QMz0aDabVA4OOT+pcnpxz85Zn+0jh9sbA0lOupq24O6hPeCp1abVeeFVt3Ac5xe2beN5HrVajd29fY4Py1SqdbaqPTbLHer1JyRFUXgXPlpL47mjYfZecUwD92faSfT7fYhjooSvz2SbDwc+kzPXQspls7jtLo+XV7QbN2iNa6xuBy8IRoJ0qvHcdd0xBI6b1ISHZaXCZGXiCFN/I/AEYeDj+/7o8VA2zP/Kx/ORMAxDupqGruvohjHoPEk0jX/CKIowElH66WlxXDiL9J8wjaFk2pqzCr8BvweDA0Ym4KcAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "bar server",
        "title": "bar server",
        "src": "/tech-academy-apac/static/8d27763eb8390e67235c71cf9f0af33b/3cbba/bar-server.png",
        "srcSet": ["/tech-academy-apac/static/8d27763eb8390e67235c71cf9f0af33b/7fc1e/bar-server.png 288w", "/tech-academy-apac/static/8d27763eb8390e67235c71cf9f0af33b/a5df1/bar-server.png 576w", "/tech-academy-apac/static/8d27763eb8390e67235c71cf9f0af33b/3cbba/bar-server.png 1152w", "/tech-academy-apac/static/8d27763eb8390e67235c71cf9f0af33b/0b124/bar-server.png 1728w", "/tech-academy-apac/static/8d27763eb8390e67235c71cf9f0af33b/4ea69/bar-server.png 2304w", "/tech-academy-apac/static/8d27763eb8390e67235c71cf9f0af33b/9959f/bar-server.png 3284w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`You do not need to use the configuration package (configuration package contains the files that you can use for App Connect Enterprise works with Databases, Event Streams, etc) click `}<strong parentName="li">{`Next`}</strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "37.15277777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAIAAACHqfpvAAAACXBIWXMAAAsTAAALEwEAmpwYAAABFklEQVQY03WQz06DQBDGeWD1JQRtaoyx2CfwYuKdWCqlUCrlYuLNU2MTAzQFQtmBwsKyTqEQY+LvMt/O7jd/Vjg7vzCXjvIy0XVdm83U6XSiqqhN0zQMw7IsRVFGsvwwursfP13Kr7djZa7PLWuBV8JweMM5PxRlwThlvK5r3tFqALDt1WppOm9rzc4dJ2IVax8Ig8Yc7/dJAgmBIs/LsqSUFg15c2zrfYfscUGfnSqnFWMVIlxdD7Is+9ps/O2RsCEIAtRRFLV6twu2vve59rX30PiIKnaaThBFEYPneYSQNE2hAz1xHPcZAnDIoKZQlykudDJLkoTBdd0E5+7AQtjzd6ZJHvcikPb/8q8ZO/8xt+AsvfkHIZ93IC1vCZIAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ace mq configuration",
        "title": "ace mq configuration",
        "src": "/tech-academy-apac/static/0e3d0f6d70d90c0667606e2c9c06909c/3cbba/ace-mq-configuration.png",
        "srcSet": ["/tech-academy-apac/static/0e3d0f6d70d90c0667606e2c9c06909c/7fc1e/ace-mq-configuration.png 288w", "/tech-academy-apac/static/0e3d0f6d70d90c0667606e2c9c06909c/a5df1/ace-mq-configuration.png 576w", "/tech-academy-apac/static/0e3d0f6d70d90c0667606e2c9c06909c/3cbba/ace-mq-configuration.png 1152w", "/tech-academy-apac/static/0e3d0f6d70d90c0667606e2c9c06909c/fcb9c/ace-mq-configuration.png 1681w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">{`On Create an Integration Server page, enter the Integration Server name as `}<strong parentName="li">{`neworder`}</strong>{` (1). Then click `}<strong parentName="li">{`Create`}</strong>{` (2).`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "61.45833333333333%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAABYlAAAWJQFJUiTwAAAByklEQVQoz4WS207bQBCG/cpJpFzkPhKIdygQSLBpQqQKiXdAEacgykVVuY2b2s76vOtDCPqZWWIpUQux9Gu9s7vfzvw7RrfbhXk+xMlpH4PBAJZl4ZxkmSbMDzQcDjEej3FBGll9jPqHuDBPcHX5DUan00FRreD5AkEQIAxDRHGG1Ss+/CaTCb4cHsHqH+Po7A4HX5fYOw5xc+vDaLfbSGWB346HXzNXy3YE5l6MKEqQJNtK0xS2bePhYYqnxynupzaupwLXdy5+/nBgNBoNKmGEvf199Ho9+L6PhaBM4xhS5cikRJZlWyqKAstlhaqqsKxyvFQSqxdFF8Ywms0mZRLDcWYQQugDIUH92QwyEJBkQU6APM+3pJTSklJR1nyRJE7EwBYFFBYECclDXkjFAvOnR3jP3zW0KMt/gJtgTkLKNbDVammj2R8OslLakJBXXLLUWbzHudSS4DzW+hS4ueB5nn6AjLX2juf1w/BcrS/bCeQxpkfhA5xRnRWDoihESuYr2leW797uBPJBltoolw/yJUFI7USex2lOtmS6gnrPp0BucgbUcI6zDX/mLv56gRa3F+/ZmSH/cz8ytPaL467r6tZK1iX/z8M3ZP5tRbh3iMYAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "create mqapi",
        "title": "create mqapi",
        "src": "/tech-academy-apac/static/9fe08bb6dc08ae4835e239bd30a5a5f7/3cbba/create-mqapi.png",
        "srcSet": ["/tech-academy-apac/static/9fe08bb6dc08ae4835e239bd30a5a5f7/7fc1e/create-mqapi.png 288w", "/tech-academy-apac/static/9fe08bb6dc08ae4835e239bd30a5a5f7/a5df1/create-mqapi.png 576w", "/tech-academy-apac/static/9fe08bb6dc08ae4835e239bd30a5a5f7/3cbba/create-mqapi.png 1152w", "/tech-academy-apac/static/9fe08bb6dc08ae4835e239bd30a5a5f7/0b124/create-mqapi.png 1728w", "/tech-academy-apac/static/9fe08bb6dc08ae4835e239bd30a5a5f7/4ea69/create-mqapi.png 2304w", "/tech-academy-apac/static/9fe08bb6dc08ae4835e239bd30a5a5f7/9959f/create-mqapi.png 3284w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`  Great, your Integration Server was created!`}</p>
    <p>{`  `}<inlineCode parentName="p">{`Note:`}</inlineCode>{` The deployment process takes up to 5 minutes, refresh the browser to see the BAR file deployed and started.`}</p>
    <hr></hr>
    <h2>{`4 - Testing the API`}</h2>
    <ol>
      <li parentName="ol">{`Here you can see the App Connect Enterprise Dashboard with the Integration Server neworder deployed and started. Click the `}<strong parentName="li">{`neworder`}</strong>{` server icon.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "45.138888888888886%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAIAAAC9o5sfAAAACXBIWXMAAAsTAAALEwEAmpwYAAAArUlEQVQoz73NMQrCMBTG8ZxXvYKgoA2tLorQpeAFTApOrauDq5OLqzqImDTvpUhTEqMXMDr4H77t9x7pdHtFUTLGcs7zTzHOV4xlWTYc9NM0JbP5wjlnjHEBWWv9yqpab3aH44nEceJsq64XLQQGpDUC1sutK/cNmSRTfwzVuUEApUI8AGioEBSh45HHj8aE45d/L6FR5FyL91stBX4ZoZT6z0IIQPwRSynxz/gJMLnnY+AJUHcAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ace mq neworder server",
        "title": "ace mq neworder server",
        "src": "/tech-academy-apac/static/c6ffb5cf938aea8a0fa88ddd9874f3bc/3cbba/ace-mq-neworder-server.png",
        "srcSet": ["/tech-academy-apac/static/c6ffb5cf938aea8a0fa88ddd9874f3bc/7fc1e/ace-mq-neworder-server.png 288w", "/tech-academy-apac/static/c6ffb5cf938aea8a0fa88ddd9874f3bc/a5df1/ace-mq-neworder-server.png 576w", "/tech-academy-apac/static/c6ffb5cf938aea8a0fa88ddd9874f3bc/3cbba/ace-mq-neworder-server.png 1152w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">
        <p parentName="li">{`The next window shows the API in started state. Click on the tile to get the details.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the next page navigate to the operation implemented in your flow (`}<strong parentName="p">{`POST /contacts`}</strong>{`). Then click on the `}<strong parentName="p">{`Try it`}</strong>{` tab followed by the `}<strong parentName="p">{`Generate`}</strong>{` hyperlink to generate some test data. Review the data generated and click the `}<strong parentName="p">{`Send`}</strong>{` button.`}</p>
      </li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAAsTAAALEwEAmpwYAAABPklEQVQoz5WRX2vCMBTF+/1Rq69jvsletDJwn2AMh2wwfJsOO8WqVVubpGnzP921rsKcMPYjhOSSc89J4tRqtZ7X73Tuut2u53k9rwd4f9Lv3w8GTrvdLopCKVX8H6feaAQEzdcrjHGW0cUu9KPIaKMqZIX6CaXUqbtugJJnf4rTVCsZ8XxBUyUk51xcg5cYY2B2ms0mBHjbBOBbGBNkaSS5FpIxprW+cFNa2zKwLexR7Jbiz/2W5hksmFbaWikEIeS3J3SPBZtRfDzJ2LdzijHL89MzJEpkZbDT1pYYe7T0CZ6gGPwzGGdxgpK8Eq9yOt5vRtP38XTiR1tZ3RNYHuIyuZ0zlIPYdV0QIITOYoArNQs3frheoQO88zm51TrehcOP5eOCQNVptVoXYmh89VdP1dfR0+3Dy82Q4ZR8AUylJahwCBjwAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "test api",
        "title": "test api",
        "src": "/tech-academy-apac/static/09d01482210160fb53513d39d2834080/3cbba/test-api.png",
        "srcSet": ["/tech-academy-apac/static/09d01482210160fb53513d39d2834080/7fc1e/test-api.png 288w", "/tech-academy-apac/static/09d01482210160fb53513d39d2834080/a5df1/test-api.png 576w", "/tech-academy-apac/static/09d01482210160fb53513d39d2834080/3cbba/test-api.png 1152w", "/tech-academy-apac/static/09d01482210160fb53513d39d2834080/0b124/test-api.png 1728w", "/tech-academy-apac/static/09d01482210160fb53513d39d2834080/277bd/test-api.png 1919w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`After a moment you will get a response back. If everything is OK you will receive a `}<strong parentName="li"><em parentName="strong">{`200`}</em></strong>{` response code indicating the request was successful and the same payload you sent plus some metadata including a timestamp showing the request completed few seconds ago.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABgElEQVQoz52SzU/CQBDF+fc5Ee6EEwkQoKbq0YvxaOLBiydQC9gu0A/a7vZj2z5nNlBjJNG4yS+7s9N9O/umnW63C8uyMBqNMJ1OsVgsMJ/PzTybzTAcDg3j8djkJ5NJC8e2bePavsKNbWFGOp3BYAAeTdPgP6OpNVQJ5Ke40+v1zOJwOCBJEuR5jrIsobVGlmUmZnjNcI4pigJ13eDh/g7j2ydYjzDnW8EwDKGUQlVVqJva7O08D6vVCo7jQAgB3/fNoZSI4xi60t+q5YsvCtL7UdYVXsQHgjRBRdVq2uccV87wHtv0BcwLfgjq04cs+Lzd4HV/wDb04R4jeEwcQcRHrKMAudbf/L8oeB4ZCQZxArFx8b5/h+u7CI+hebIk3DCALIvfBdsk+eOTTzuHfPSWiEgskwoyTZFLiT1Vq6g5f66woMZsoxCbD4GlWGMT7CAo9qiyHc1v/h5Klz+b0u/3W0FJN59NZxK6Mc4U0iw381FJQp2Q7e9lmkQNYzs+AQR86tmWcBWoAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 44",
        "title": "ACE Toolkit integration with ES Configuration Step 44",
        "src": "/tech-academy-apac/static/c42668936b1bdef07df5b9f3155508df/3cbba/2021-09-19_12-48-15.png",
        "srcSet": ["/tech-academy-apac/static/c42668936b1bdef07df5b9f3155508df/7fc1e/2021-09-19_12-48-15.png 288w", "/tech-academy-apac/static/c42668936b1bdef07df5b9f3155508df/a5df1/2021-09-19_12-48-15.png 576w", "/tech-academy-apac/static/c42668936b1bdef07df5b9f3155508df/3cbba/2021-09-19_12-48-15.png 1152w", "/tech-academy-apac/static/c42668936b1bdef07df5b9f3155508df/0b124/2021-09-19_12-48-15.png 1728w", "/tech-academy-apac/static/c42668936b1bdef07df5b9f3155508df/277bd/2021-09-19_12-48-15.png 1919w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`Now, let’s check the message arrived in the NEWORDER queue in IBM MQ. Let’s use IBM MQ Console to check it. Open the `}<strong parentName="li">{`Menu`}</strong>{`, and on `}<strong parentName="li">{`Run`}</strong>{` section, click on `}<strong parentName="li">{`Messaging`}</strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "37.84722222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAIAAAB2/0i6AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAw0lEQVQY05WPuw6CQBBFt8WFeiFLRFiDLBpprOz8CPHxAxCQD6cjREBYHq4QrTTgqeYWZ+YOsCklhCCEnK1zvZxP7tGdDDBXFrVtWZbDW9R1XcWabjKAqCpGSBCEKHrJrP5H3unaZjGHohgGAc95ntd1/ehpxgCHNXWIIUqS53lcvvdkWVaWZTUG2FvmEuMZhIOcJEkcx1yeVFszDKQoIoS+7w+1+U0+tAOf4RtA13WMMXzLRVHwZ9p+MWMsTVMef11+Aoe/bSLfPAmUAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "open mq",
        "title": "open mq",
        "src": "/tech-academy-apac/static/3e14ae1e4fdf412a5e8f5a5320435cc2/3cbba/open-mq.png",
        "srcSet": ["/tech-academy-apac/static/3e14ae1e4fdf412a5e8f5a5320435cc2/7fc1e/open-mq.png 288w", "/tech-academy-apac/static/3e14ae1e4fdf412a5e8f5a5320435cc2/a5df1/open-mq.png 576w", "/tech-academy-apac/static/3e14ae1e4fdf412a5e8f5a5320435cc2/3cbba/open-mq.png 1152w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`6.Click Manage `}<strong parentName="p">{`QMGRDEMO`}</strong>{`.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "66.31944444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAACCklEQVQ4y5WSXY/SQBSG+yf4CLAXcmNM/HOsxt/DHZ/qvbeyXJAVdtlA1KwxQEFa+kXbaUtpeT1nlgrEC9cmJ3OmM+eZ9z0zypu373Bdq6FGUa/X0e120W630el00Gq10Gw2/0TjLD+fNxoNtKjm/YePUF6+eo1q9QVFFdPpFL7vQ9M0uK6LNE3xf98BytVVBeVyGaVSCYPBAJZlYblcyjBNE9utC+E5+KYKfLoT8F0Hd/djWKaBuS6gGzYef/yEbTvYkgiFQfl8XgJHo5FUxSqDIJCj53kIA4H5ysD4cQNB/9aaDk3f4GEWYrXxsViocBxH7lcKhQJyuZwEDodDxHEs7TLoKVxEux2+Tsbo304wMxLYloH7yXekOw8PiwT9sYpfyzmJCKEUi8UTkBTG+z3Z3D7Bjgr5ZNO0YFI7eM4HCuHDp1y3SL26hmkY8IU4AcuVCm57PeyoN2Kjw9c1eKultMsKdxRhGCKKIpnzyG3ZxxGSfSz/ScvnwGHvMwI6lZXESYLUp/7RpuR423tSz1AuPhwOx3kk4Snt57WTZQKO+jdw6GZn8zlCKkrZnm2TPSGLz/vLOYN5jZVmDi4UfrnpISS7lqoiMDYItTUc25I9ZTtczDlDGcLzDJjlF5fCz4atBHSStEQ2GPTcYOV/AdkaL/KYEPD0fP4dF5eSAbkXvMg2uCfZxufGb6AzcoEAF46xAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "qmg demo",
        "title": "qmg demo",
        "src": "/tech-academy-apac/static/99cbbfa90206dcc71f84aa85f0394862/3cbba/qmg-demo.png",
        "srcSet": ["/tech-academy-apac/static/99cbbfa90206dcc71f84aa85f0394862/7fc1e/qmg-demo.png 288w", "/tech-academy-apac/static/99cbbfa90206dcc71f84aa85f0394862/a5df1/qmg-demo.png 576w", "/tech-academy-apac/static/99cbbfa90206dcc71f84aa85f0394862/3cbba/qmg-demo.png 1152w", "/tech-academy-apac/static/99cbbfa90206dcc71f84aa85f0394862/0b124/qmg-demo.png 1728w", "/tech-academy-apac/static/99cbbfa90206dcc71f84aa85f0394862/4ea69/qmg-demo.png 2304w", "/tech-academy-apac/static/99cbbfa90206dcc71f84aa85f0394862/9959f/qmg-demo.png 3284w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">{`Here you can see that a new message has arrived in `}<strong parentName="li">{`CP4I.DEMO.API.Q`}</strong>{` queue.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "72.91666666666666%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAABYlAAAWJQFJUiTwAAACZElEQVQ4y5VUS27bMBT0DeSs4lWukV1zkgB14GRRoECaC3WRRW3Y7g2CXCHLAg3gxp84kiiR1P9DcfpIWWmEoAVKYPDIZ3LeE2foweTyEufn5xiPxzDzyWSCy0O8urqy8eLi4t8Yf8Snz9f4cnODwdnZB5yenuLu7h610iiKHFmWIc9zSCmhlML/jMHJyQmGwyFmsxnSrETAIwghEEURGGNIkoTybYGqqnooy9IiL1qY+SvhfD63FaqyAjTsj2maoWkaNNSliWEYUi6F1tp2HsfxOwyOj4/hOEMsFgtUdYmEcyI0B2pwHiKSnAgLS2jWYRDYAprWSdKSJISU5uZrBqPRyHb4bTpHlAPPvoDHE7hBDF+WYJGifIMoUxYy+7MWSWXBCYz2xnGPcIaE7vDF9eD6gYUXCLiMg4UCe5dht/co+tr1Q3gs1B4TWvAA9w9SX39N8WP9hnA2nZIQKfYvDDwIIenzRBjAd18ohthu1nharbDfbbHbrLVHeUniScG1zwR+PQsISXc4ojscHh1hfnuLfM/gP66Q0eEO8dMK6ebJIt9tdPG81fLxJ2opSDojnx02FuQE26EzdKwoxnE8KunS61ZZQlWQIHVN6pdQVaUpp3OykaprbYZ1QaO1Uo31b0voOFgul7ZUnCt0pQ1qo6hRnQ6aaK1liA9r3Q7rgh7hoiPM6m6jRU3dGYuogxfNadNtY9o6kHWd9gkXSzR/IzwYueuqbAl7+94RLpffbYdp0fTeZveWm/4nv87fRkvYvhQHU/JhVij4gURCz8u43r5TUq4gYbpoct2fh+neFDQ5Mzf53wTXFVT/KpIPAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "result",
        "title": "result",
        "src": "/tech-academy-apac/static/ff621e69bbda8bae4def1e9a18380051/3cbba/result.png",
        "srcSet": ["/tech-academy-apac/static/ff621e69bbda8bae4def1e9a18380051/7fc1e/result.png 288w", "/tech-academy-apac/static/ff621e69bbda8bae4def1e9a18380051/a5df1/result.png 576w", "/tech-academy-apac/static/ff621e69bbda8bae4def1e9a18380051/3cbba/result.png 1152w", "/tech-academy-apac/static/ff621e69bbda8bae4def1e9a18380051/0b124/result.png 1728w", "/tech-academy-apac/static/ff621e69bbda8bae4def1e9a18380051/4ea69/result.png 2304w", "/tech-academy-apac/static/ff621e69bbda8bae4def1e9a18380051/9959f/result.png 3284w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`8.You are welcome, to click on the `}<strong parentName="p">{`CP4I.DEMO.API.Q`}</strong>{` queue, to explore the message.`}</p>
    <p>{`  Congratulations! Here you completed this lab.`}</p>
    <hr></hr>
    <h2>{`Summary`}</h2>
    <p>{`You have successfully completed this lab. In this lab you learned how to:`}</p>
    <ul>
      <li parentName="ul">{`Create an integration flow that connects to a message queue`}</li>
      <li parentName="ul">{`Deploy the integration flow as a container in Kubernetes`}</li>
      <li parentName="ul">{`Check the message using MQ Web Console`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      